/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as SignedOutRouteImport } from './routes/signed-out'
import { Route as AuthIndexRouteImport } from './routes/_auth/index'
import { Route as AuthMeRouteImport } from './routes/_auth/me'
import { Route as AuthOnboardingRouteImport } from './routes/_auth/onboarding'
import { Route as AuthSpacesRouteImport } from './routes/_auth/spaces'
import { Route as InvitationsTokenRouteImport } from './routes/invitations.$token'
import { Route as InvitationsAcceptRouteImport } from './routes/invitations.accept'
import { Route as LTokenRouteImport } from './routes/l.$token'
import { Route as QTokenRouteImport } from './routes/q.$token'
import { Route as TTokenRouteImport } from './routes/t.$token'
import { Route as AuthCallsMeetingIdRouteImport } from './routes/_auth/calls.$meetingId'
import { Route as AuthInvitationsSpacesRouteImport } from './routes/_auth/invitations.spaces'
import { Route as AuthMeIndexRouteImport } from './routes/_auth/me.index'
import { Route as AuthMeNotificationsRouteImport } from './routes/_auth/me.notifications'
import { Route as AuthMeProfileRouteImport } from './routes/_auth/me.profile'
import { Route as AuthMeSecurityRouteImport } from './routes/_auth/me.security'
import { Route as AuthMeetingsMeetingIdRouteImport } from './routes/_auth/meetings.$meetingId'
import { Route as AuthMeetingsGuestRouteImport } from './routes/_auth/meetings.guest'
import { Route as AuthMinutesNewRouteImport } from './routes/_auth/minutes.new'
import { Route as AuthOOrgIdRouteImport } from './routes/_auth/o.$orgId'
import { Route as AuthSSpaceIdRouteImport } from './routes/_auth/s.$spaceId'
import { Route as AuthSpacesIndexRouteImport } from './routes/_auth/spaces.index'
import { Route as MeetingsJoinTokenRouteImport } from './routes/meetings.join.$token'
import { Route as AuthMinutesSpaceIdMinutesIdRouteImport } from './routes/_auth/minutes.$spaceId.$minutesId'
import { Route as AuthOOrgIdIndexRouteImport } from './routes/_auth/o.$orgId/index'
import { Route as AuthOOrgIdActivityRouteImport } from './routes/_auth/o.$orgId/activity'
import { Route as AuthOOrgIdAdminRouteImport } from './routes/_auth/o.$orgId/admin'
import { Route as AuthOOrgIdCalendarRouteImport } from './routes/_auth/o.$orgId/calendar'
import { Route as AuthOOrgIdDirectoryRouteImport } from './routes/_auth/o.$orgId/directory'
import { Route as AuthOOrgIdFilesRouteImport } from './routes/_auth/o.$orgId/files'
import { Route as AuthOOrgIdFinanceRouteImport } from './routes/_auth/o.$orgId/finance'
import { Route as AuthOOrgIdMoreRouteImport } from './routes/_auth/o.$orgId/more'
import { Route as AuthOOrgIdPartnershipsRouteImport } from './routes/_auth/o.$orgId/partnerships'
import { Route as AuthOOrgIdSearchRouteImport } from './routes/_auth/o.$orgId/search'
import { Route as AuthOOrgIdSpaceApprovalsRouteImport } from './routes/_auth/o.$orgId/space-approvals'
import { Route as AuthOOrgIdTimesheetsRouteImport } from './routes/_auth/o.$orgId/timesheets'
import { Route as AuthSSpaceIdIndexRouteImport } from './routes/_auth/s.$spaceId.index'
import { Route as AuthSSpaceIdTabRouteImport } from './routes/_auth/s.$spaceId.$tab'
import { Route as AuthOOrgIdAdminIndexRouteImport } from './routes/_auth/o.$orgId/admin.index'
import { Route as AuthOOrgIdAdminAuditRouteImport } from './routes/_auth/o.$orgId/admin.audit'
import { Route as AuthOOrgIdAdminChecklistsRouteImport } from './routes/_auth/o.$orgId/admin.checklists'
import { Route as AuthOOrgIdAdminDataRouteImport } from './routes/_auth/o.$orgId/admin.data'
import { Route as AuthOOrgIdAdminDocumentsRouteImport } from './routes/_auth/o.$orgId/admin.documents'
import { Route as AuthOOrgIdAdminFiscalRouteImport } from './routes/_auth/o.$orgId/admin.fiscal'
import { Route as AuthOOrgIdAdminMembersRouteImport } from './routes/_auth/o.$orgId/admin.members'
import { Route as AuthOOrgIdAdminPoliciesRouteImport } from './routes/_auth/o.$orgId/admin.policies'
import { Route as AuthOOrgIdAdminProfileRouteImport } from './routes/_auth/o.$orgId/admin.profile'
import { Route as AuthOOrgIdAdminRolesRouteImport } from './routes/_auth/o.$orgId/admin.roles'
import { Route as AuthOOrgIdAdminStorageRouteImport } from './routes/_auth/o.$orgId/admin.storage'
import { Route as AuthOOrgIdAdminSubscriptionRouteImport } from './routes/_auth/o.$orgId/admin.subscription'
import { Route as AuthOOrgIdAdminTemplatesRouteImport } from './routes/_auth/o.$orgId/admin.templates'
import { Route as AuthOOrgIdChatIndexRouteImport } from './routes/_auth/o.$orgId/chat.index'
import { Route as AuthOOrgIdChatChannelIdRouteImport } from './routes/_auth/o.$orgId/chat.$channelId'
import { Route as AuthOOrgIdClientsIndexRouteImport } from './routes/_auth/o.$orgId/clients.index'
import { Route as AuthOOrgIdClientsClientIdRouteImport } from './routes/_auth/o.$orgId/clients.$clientId'
import { Route as AuthOOrgIdFinanceIndexRouteImport } from './routes/_auth/o.$orgId/finance.index'
import { Route as AuthOOrgIdFinanceAccountingRouteImport } from './routes/_auth/o.$orgId/finance.accounting'
import { Route as AuthOOrgIdFinanceCostRatesRouteImport } from './routes/_auth/o.$orgId/finance.cost-rates'
import { Route as AuthOOrgIdFinanceDashboardRouteImport } from './routes/_auth/o.$orgId/finance.dashboard'
import { Route as AuthOOrgIdFinanceEinvoicingRouteImport } from './routes/_auth/o.$orgId/finance.einvoicing'
import { Route as AuthOOrgIdFinanceManagementRouteImport } from './routes/_auth/o.$orgId/finance.management'
import { Route as AuthOOrgIdFinancePaymentsRouteImport } from './routes/_auth/o.$orgId/finance.payments'
import { Route as AuthOOrgIdFinanceProfitabilityRouteImport } from './routes/_auth/o.$orgId/finance.profitability'
import { Route as AuthOOrgIdFinanceSupplierInvoicesRouteImport } from './routes/_auth/o.$orgId/finance.supplier-invoices'
import { Route as AuthOOrgIdFinanceSuppliersRouteImport } from './routes/_auth/o.$orgId/finance.suppliers'
import { Route as AuthOOrgIdFinanceTreasuryRouteImport } from './routes/_auth/o.$orgId/finance.treasury'
import { Route as AuthOOrgIdFinanceWithholdingRouteImport } from './routes/_auth/o.$orgId/finance.withholding'
import { Route as AuthOOrgIdMeetingsMeetingIdRouteImport } from './routes/_auth/o.$orgId/meetings.$meetingId'
import { Route as AuthOOrgIdProjectsIndexRouteImport } from './routes/_auth/o.$orgId/projects.index'
import { Route as AuthOOrgIdSignaturesIndexRouteImport } from './routes/_auth/o.$orgId/signatures.index'
import { Route as AuthOOrgIdSignaturesRequestIdRouteImport } from './routes/_auth/o.$orgId/signatures.$requestId'
import { Route as AuthOOrgIdTendersIndexRouteImport } from './routes/_auth/o.$orgId/tenders.index'
import { Route as AuthOOrgIdTendersTenderIdRouteImport } from './routes/_auth/o.$orgId/tenders.$tenderId'
import { Route as AuthOOrgIdTendersVaultRouteImport } from './routes/_auth/o.$orgId/tenders.vault'
import { Route as AuthOOrgIdFinanceContractsIndexRouteImport } from './routes/_auth/o.$orgId/finance.contracts.index'
import { Route as AuthOOrgIdFinanceContractsNewRouteImport } from './routes/_auth/o.$orgId/finance.contracts.new'
import { Route as AuthOOrgIdFinanceExpensesIndexRouteImport } from './routes/_auth/o.$orgId/finance.expenses.index'
import { Route as AuthOOrgIdFinanceExpensesApprovalsRouteImport } from './routes/_auth/o.$orgId/finance.expenses.approvals'
import { Route as AuthOOrgIdFinanceInvoicesIndexRouteImport } from './routes/_auth/o.$orgId/finance.invoices.index'
import { Route as AuthOOrgIdFinanceInvoicesInvoiceIdRouteImport } from './routes/_auth/o.$orgId/finance.invoices.$invoiceId'
import { Route as AuthOOrgIdFinanceInvoicesNewRouteImport } from './routes/_auth/o.$orgId/finance.invoices.new'
import { Route as AuthOOrgIdFinanceQuotesIndexRouteImport } from './routes/_auth/o.$orgId/finance.quotes.index'
import { Route as AuthOOrgIdFinanceQuotesQuoteIdRouteImport } from './routes/_auth/o.$orgId/finance.quotes.$quoteId'
import { Route as AuthOOrgIdFinanceQuotesNewRouteImport } from './routes/_auth/o.$orgId/finance.quotes.new'
import { Route as AuthOOrgIdProjectsProjectIdIndexRouteImport } from './routes/_auth/o.$orgId/projects.$projectId.index'
import { Route as AuthOOrgIdProjectsProjectIdTabRouteImport } from './routes/_auth/o.$orgId/projects.$projectId.$tab'
import { Route as AuthOOrgIdFinanceContractsContractIdIndexRouteImport } from './routes/_auth/o.$orgId/finance.contracts.$contractId.index'
import { Route as AuthOOrgIdFinanceContractsContractIdProgressRouteImport } from './routes/_auth/o.$orgId/finance.contracts.$contractId.progress'
import { Route as AuthOOrgIdProjectsProjectIdDocumentsDocumentIdRouteImport } from './routes/_auth/o.$orgId/projects.$projectId.documents.$documentId'
import { Route as AuthOOrgIdProjectsProjectIdWorkspaceSectionRouteImport } from './routes/_auth/o.$orgId/projects.$projectId.workspace.$section'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const SignedOutRoute = SignedOutRouteImport.update({
  id: '/signed-out',
  path: '/signed-out',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMeRoute = AuthMeRouteImport.update({
  id: '/me',
  path: '/me',
  getParentRoute: () => AuthRoute,
} as any)
const AuthOnboardingRoute = AuthOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSpacesRoute = AuthSpacesRouteImport.update({
  id: '/spaces',
  path: '/spaces',
  getParentRoute: () => AuthRoute,
} as any)
const InvitationsTokenRoute = InvitationsTokenRouteImport.update({
  id: '/invitations/$token',
  path: '/invitations/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const InvitationsAcceptRoute = InvitationsAcceptRouteImport.update({
  id: '/invitations/accept',
  path: '/invitations/accept',
  getParentRoute: () => rootRouteImport,
} as any)
const LTokenRoute = LTokenRouteImport.update({
  id: '/l/$token',
  path: '/l/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const QTokenRoute = QTokenRouteImport.update({
  id: '/q/$token',
  path: '/q/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const TTokenRoute = TTokenRouteImport.update({
  id: '/t/$token',
  path: '/t/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallsMeetingIdRoute = AuthCallsMeetingIdRouteImport.update({
  id: '/calls/$meetingId',
  path: '/calls/$meetingId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInvitationsSpacesRoute = AuthInvitationsSpacesRouteImport.update({
  id: '/invitations/spaces',
  path: '/invitations/spaces',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMeIndexRoute = AuthMeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthMeRoute,
} as any)
const AuthMeNotificationsRoute = AuthMeNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AuthMeRoute,
} as any)
const AuthMeProfileRoute = AuthMeProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthMeRoute,
} as any)
const AuthMeSecurityRoute = AuthMeSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => AuthMeRoute,
} as any)
const AuthMeetingsMeetingIdRoute = AuthMeetingsMeetingIdRouteImport.update({
  id: '/meetings/$meetingId',
  path: '/meetings/$meetingId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMeetingsGuestRoute = AuthMeetingsGuestRouteImport.update({
  id: '/meetings/guest',
  path: '/meetings/guest',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMinutesNewRoute = AuthMinutesNewRouteImport.update({
  id: '/minutes/new',
  path: '/minutes/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthOOrgIdRoute = AuthOOrgIdRouteImport.update({
  id: '/o/$orgId',
  path: '/o/$orgId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSSpaceIdRoute = AuthSSpaceIdRouteImport.update({
  id: '/s/$spaceId',
  path: '/s/$spaceId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSpacesIndexRoute = AuthSpacesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthSpacesRoute,
} as any)
const MeetingsJoinTokenRoute = MeetingsJoinTokenRouteImport.update({
  id: '/meetings/join/$token',
  path: '/meetings/join/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthMinutesSpaceIdMinutesIdRoute =
  AuthMinutesSpaceIdMinutesIdRouteImport.update({
    id: '/minutes/$spaceId/$minutesId',
    path: '/minutes/$spaceId/$minutesId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthOOrgIdIndexRoute = AuthOOrgIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthOOrgIdRoute,
} as any)
const AuthOOrgIdActivityRoute = AuthOOrgIdActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AuthOOrgIdRoute,
} as any)
const AuthOOrgIdAdminRoute = AuthOOrgIdAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthOOrgIdRoute,
} as any)
const AuthOOrgIdCalendarRoute = AuthOOrgIdCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AuthOOrgIdRoute,
} as any)
const AuthOOrgIdDirectoryRoute = AuthOOrgIdDirectoryRouteImport.update({
  id: '/directory',
  path: '/directory',
  getParentRoute: () => AuthOOrgIdRoute,
} as any)
const AuthOOrgIdFilesRoute = AuthOOrgIdFilesRouteImport.update({
  id: '/files',
  path: '/files',
  getParentRoute: () => AuthOOrgIdRoute,
} as any)
const AuthOOrgIdFinanceRoute = AuthOOrgIdFinanceRouteImport.update({
  id: '/finance',
  path: '/finance',
  getParentRoute: () => AuthOOrgIdRoute,
} as any)
const AuthOOrgIdMoreRoute = AuthOOrgIdMoreRouteImport.update({
  id: '/more',
  path: '/more',
  getParentRoute: () => AuthOOrgIdRoute,
} as any)
const AuthOOrgIdPartnershipsRoute = AuthOOrgIdPartnershipsRouteImport.update({
  id: '/partnerships',
  path: '/partnerships',
  getParentRoute: () => AuthOOrgIdRoute,
} as any)
const AuthOOrgIdSearchRoute = AuthOOrgIdSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AuthOOrgIdRoute,
} as any)
const AuthOOrgIdSpaceApprovalsRoute =
  AuthOOrgIdSpaceApprovalsRouteImport.update({
    id: '/space-approvals',
    path: '/space-approvals',
    getParentRoute: () => AuthOOrgIdRoute,
  } as any)
const AuthOOrgIdTimesheetsRoute = AuthOOrgIdTimesheetsRouteImport.update({
  id: '/timesheets',
  path: '/timesheets',
  getParentRoute: () => AuthOOrgIdRoute,
} as any)
const AuthSSpaceIdIndexRoute = AuthSSpaceIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthSSpaceIdRoute,
} as any)
const AuthSSpaceIdTabRoute = AuthSSpaceIdTabRouteImport.update({
  id: '/$tab',
  path: '/$tab',
  getParentRoute: () => AuthSSpaceIdRoute,
} as any)
const AuthOOrgIdAdminIndexRoute = AuthOOrgIdAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthOOrgIdAdminRoute,
} as any)
const AuthOOrgIdAdminAuditRoute = AuthOOrgIdAdminAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AuthOOrgIdAdminRoute,
} as any)
const AuthOOrgIdAdminChecklistsRoute =
  AuthOOrgIdAdminChecklistsRouteImport.update({
    id: '/checklists',
    path: '/checklists',
    getParentRoute: () => AuthOOrgIdAdminRoute,
  } as any)
const AuthOOrgIdAdminDataRoute = AuthOOrgIdAdminDataRouteImport.update({
  id: '/data',
  path: '/data',
  getParentRoute: () => AuthOOrgIdAdminRoute,
} as any)
const AuthOOrgIdAdminDocumentsRoute =
  AuthOOrgIdAdminDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => AuthOOrgIdAdminRoute,
  } as any)
const AuthOOrgIdAdminFiscalRoute = AuthOOrgIdAdminFiscalRouteImport.update({
  id: '/fiscal',
  path: '/fiscal',
  getParentRoute: () => AuthOOrgIdAdminRoute,
} as any)
const AuthOOrgIdAdminMembersRoute = AuthOOrgIdAdminMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AuthOOrgIdAdminRoute,
} as any)
const AuthOOrgIdAdminPoliciesRoute = AuthOOrgIdAdminPoliciesRouteImport.update({
  id: '/policies',
  path: '/policies',
  getParentRoute: () => AuthOOrgIdAdminRoute,
} as any)
const AuthOOrgIdAdminProfileRoute = AuthOOrgIdAdminProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthOOrgIdAdminRoute,
} as any)
const AuthOOrgIdAdminRolesRoute = AuthOOrgIdAdminRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => AuthOOrgIdAdminRoute,
} as any)
const AuthOOrgIdAdminStorageRoute = AuthOOrgIdAdminStorageRouteImport.update({
  id: '/storage',
  path: '/storage',
  getParentRoute: () => AuthOOrgIdAdminRoute,
} as any)
const AuthOOrgIdAdminSubscriptionRoute =
  AuthOOrgIdAdminSubscriptionRouteImport.update({
    id: '/subscription',
    path: '/subscription',
    getParentRoute: () => AuthOOrgIdAdminRoute,
  } as any)
const AuthOOrgIdAdminTemplatesRoute =
  AuthOOrgIdAdminTemplatesRouteImport.update({
    id: '/templates',
    path: '/templates',
    getParentRoute: () => AuthOOrgIdAdminRoute,
  } as any)
const AuthOOrgIdChatIndexRoute = AuthOOrgIdChatIndexRouteImport.update({
  id: '/chat/',
  path: '/chat/',
  getParentRoute: () => AuthOOrgIdRoute,
} as any)
const AuthOOrgIdChatChannelIdRoute = AuthOOrgIdChatChannelIdRouteImport.update({
  id: '/chat/$channelId',
  path: '/chat/$channelId',
  getParentRoute: () => AuthOOrgIdRoute,
} as any)
const AuthOOrgIdClientsIndexRoute = AuthOOrgIdClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => AuthOOrgIdRoute,
} as any)
const AuthOOrgIdClientsClientIdRoute =
  AuthOOrgIdClientsClientIdRouteImport.update({
    id: '/clients/$clientId',
    path: '/clients/$clientId',
    getParentRoute: () => AuthOOrgIdRoute,
  } as any)
const AuthOOrgIdFinanceIndexRoute = AuthOOrgIdFinanceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthOOrgIdFinanceRoute,
} as any)
const AuthOOrgIdFinanceAccountingRoute =
  AuthOOrgIdFinanceAccountingRouteImport.update({
    id: '/accounting',
    path: '/accounting',
    getParentRoute: () => AuthOOrgIdFinanceRoute,
  } as any)
const AuthOOrgIdFinanceCostRatesRoute =
  AuthOOrgIdFinanceCostRatesRouteImport.update({
    id: '/cost-rates',
    path: '/cost-rates',
    getParentRoute: () => AuthOOrgIdFinanceRoute,
  } as any)
const AuthOOrgIdFinanceDashboardRoute =
  AuthOOrgIdFinanceDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => AuthOOrgIdFinanceRoute,
  } as any)
const AuthOOrgIdFinanceEinvoicingRoute =
  AuthOOrgIdFinanceEinvoicingRouteImport.update({
    id: '/einvoicing',
    path: '/einvoicing',
    getParentRoute: () => AuthOOrgIdFinanceRoute,
  } as any)
const AuthOOrgIdFinanceManagementRoute =
  AuthOOrgIdFinanceManagementRouteImport.update({
    id: '/management',
    path: '/management',
    getParentRoute: () => AuthOOrgIdFinanceRoute,
  } as any)
const AuthOOrgIdFinancePaymentsRoute =
  AuthOOrgIdFinancePaymentsRouteImport.update({
    id: '/payments',
    path: '/payments',
    getParentRoute: () => AuthOOrgIdFinanceRoute,
  } as any)
const AuthOOrgIdFinanceProfitabilityRoute =
  AuthOOrgIdFinanceProfitabilityRouteImport.update({
    id: '/profitability',
    path: '/profitability',
    getParentRoute: () => AuthOOrgIdFinanceRoute,
  } as any)
const AuthOOrgIdFinanceSupplierInvoicesRoute =
  AuthOOrgIdFinanceSupplierInvoicesRouteImport.update({
    id: '/supplier-invoices',
    path: '/supplier-invoices',
    getParentRoute: () => AuthOOrgIdFinanceRoute,
  } as any)
const AuthOOrgIdFinanceSuppliersRoute =
  AuthOOrgIdFinanceSuppliersRouteImport.update({
    id: '/suppliers',
    path: '/suppliers',
    getParentRoute: () => AuthOOrgIdFinanceRoute,
  } as any)
const AuthOOrgIdFinanceTreasuryRoute =
  AuthOOrgIdFinanceTreasuryRouteImport.update({
    id: '/treasury',
    path: '/treasury',
    getParentRoute: () => AuthOOrgIdFinanceRoute,
  } as any)
const AuthOOrgIdFinanceWithholdingRoute =
  AuthOOrgIdFinanceWithholdingRouteImport.update({
    id: '/withholding',
    path: '/withholding',
    getParentRoute: () => AuthOOrgIdFinanceRoute,
  } as any)
const AuthOOrgIdMeetingsMeetingIdRoute =
  AuthOOrgIdMeetingsMeetingIdRouteImport.update({
    id: '/meetings/$meetingId',
    path: '/meetings/$meetingId',
    getParentRoute: () => AuthOOrgIdRoute,
  } as any)
const AuthOOrgIdProjectsIndexRoute = AuthOOrgIdProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => AuthOOrgIdRoute,
} as any)
const AuthOOrgIdSignaturesIndexRoute =
  AuthOOrgIdSignaturesIndexRouteImport.update({
    id: '/signatures/',
    path: '/signatures/',
    getParentRoute: () => AuthOOrgIdRoute,
  } as any)
const AuthOOrgIdSignaturesRequestIdRoute =
  AuthOOrgIdSignaturesRequestIdRouteImport.update({
    id: '/signatures/$requestId',
    path: '/signatures/$requestId',
    getParentRoute: () => AuthOOrgIdRoute,
  } as any)
const AuthOOrgIdTendersIndexRoute = AuthOOrgIdTendersIndexRouteImport.update({
  id: '/tenders/',
  path: '/tenders/',
  getParentRoute: () => AuthOOrgIdRoute,
} as any)
const AuthOOrgIdTendersTenderIdRoute =
  AuthOOrgIdTendersTenderIdRouteImport.update({
    id: '/tenders/$tenderId',
    path: '/tenders/$tenderId',
    getParentRoute: () => AuthOOrgIdRoute,
  } as any)
const AuthOOrgIdTendersVaultRoute = AuthOOrgIdTendersVaultRouteImport.update({
  id: '/tenders/vault',
  path: '/tenders/vault',
  getParentRoute: () => AuthOOrgIdRoute,
} as any)
const AuthOOrgIdFinanceContractsIndexRoute =
  AuthOOrgIdFinanceContractsIndexRouteImport.update({
    id: '/contracts/',
    path: '/contracts/',
    getParentRoute: () => AuthOOrgIdFinanceRoute,
  } as any)
const AuthOOrgIdFinanceContractsNewRoute =
  AuthOOrgIdFinanceContractsNewRouteImport.update({
    id: '/contracts/new',
    path: '/contracts/new',
    getParentRoute: () => AuthOOrgIdFinanceRoute,
  } as any)
const AuthOOrgIdFinanceExpensesIndexRoute =
  AuthOOrgIdFinanceExpensesIndexRouteImport.update({
    id: '/expenses/',
    path: '/expenses/',
    getParentRoute: () => AuthOOrgIdFinanceRoute,
  } as any)
const AuthOOrgIdFinanceExpensesApprovalsRoute =
  AuthOOrgIdFinanceExpensesApprovalsRouteImport.update({
    id: '/expenses/approvals',
    path: '/expenses/approvals',
    getParentRoute: () => AuthOOrgIdFinanceRoute,
  } as any)
const AuthOOrgIdFinanceInvoicesIndexRoute =
  AuthOOrgIdFinanceInvoicesIndexRouteImport.update({
    id: '/invoices/',
    path: '/invoices/',
    getParentRoute: () => AuthOOrgIdFinanceRoute,
  } as any)
const AuthOOrgIdFinanceInvoicesInvoiceIdRoute =
  AuthOOrgIdFinanceInvoicesInvoiceIdRouteImport.update({
    id: '/invoices/$invoiceId',
    path: '/invoices/$invoiceId',
    getParentRoute: () => AuthOOrgIdFinanceRoute,
  } as any)
const AuthOOrgIdFinanceInvoicesNewRoute =
  AuthOOrgIdFinanceInvoicesNewRouteImport.update({
    id: '/invoices/new',
    path: '/invoices/new',
    getParentRoute: () => AuthOOrgIdFinanceRoute,
  } as any)
const AuthOOrgIdFinanceQuotesIndexRoute =
  AuthOOrgIdFinanceQuotesIndexRouteImport.update({
    id: '/quotes/',
    path: '/quotes/',
    getParentRoute: () => AuthOOrgIdFinanceRoute,
  } as any)
const AuthOOrgIdFinanceQuotesQuoteIdRoute =
  AuthOOrgIdFinanceQuotesQuoteIdRouteImport.update({
    id: '/quotes/$quoteId',
    path: '/quotes/$quoteId',
    getParentRoute: () => AuthOOrgIdFinanceRoute,
  } as any)
const AuthOOrgIdFinanceQuotesNewRoute =
  AuthOOrgIdFinanceQuotesNewRouteImport.update({
    id: '/quotes/new',
    path: '/quotes/new',
    getParentRoute: () => AuthOOrgIdFinanceRoute,
  } as any)
const AuthOOrgIdProjectsProjectIdIndexRoute =
  AuthOOrgIdProjectsProjectIdIndexRouteImport.update({
    id: '/projects/$projectId/',
    path: '/projects/$projectId/',
    getParentRoute: () => AuthOOrgIdRoute,
  } as any)
const AuthOOrgIdProjectsProjectIdTabRoute =
  AuthOOrgIdProjectsProjectIdTabRouteImport.update({
    id: '/projects/$projectId/$tab',
    path: '/projects/$projectId/$tab',
    getParentRoute: () => AuthOOrgIdRoute,
  } as any)
const AuthOOrgIdFinanceContractsContractIdIndexRoute =
  AuthOOrgIdFinanceContractsContractIdIndexRouteImport.update({
    id: '/contracts/$contractId/',
    path: '/contracts/$contractId/',
    getParentRoute: () => AuthOOrgIdFinanceRoute,
  } as any)
const AuthOOrgIdFinanceContractsContractIdProgressRoute =
  AuthOOrgIdFinanceContractsContractIdProgressRouteImport.update({
    id: '/contracts/$contractId/progress',
    path: '/contracts/$contractId/progress',
    getParentRoute: () => AuthOOrgIdFinanceRoute,
  } as any)
const AuthOOrgIdProjectsProjectIdDocumentsDocumentIdRoute =
  AuthOOrgIdProjectsProjectIdDocumentsDocumentIdRouteImport.update({
    id: '/projects/$projectId/documents/$documentId',
    path: '/projects/$projectId/documents/$documentId',
    getParentRoute: () => AuthOOrgIdRoute,
  } as any)
const AuthOOrgIdProjectsProjectIdWorkspaceSectionRoute =
  AuthOOrgIdProjectsProjectIdWorkspaceSectionRouteImport.update({
    id: '/projects/$projectId/workspace/$section',
    path: '/projects/$projectId/workspace/$section',
    getParentRoute: () => AuthOOrgIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthIndexRoute
  '/signed-out': typeof SignedOutRoute
  '/me': typeof AuthMeRouteWithChildren
  '/onboarding': typeof AuthOnboardingRoute
  '/spaces': typeof AuthSpacesRouteWithChildren
  '/invitations/$token': typeof InvitationsTokenRoute
  '/invitations/accept': typeof InvitationsAcceptRoute
  '/l/$token': typeof LTokenRoute
  '/q/$token': typeof QTokenRoute
  '/t/$token': typeof TTokenRoute
  '/calls/$meetingId': typeof AuthCallsMeetingIdRoute
  '/invitations/spaces': typeof AuthInvitationsSpacesRoute
  '/me/notifications': typeof AuthMeNotificationsRoute
  '/me/profile': typeof AuthMeProfileRoute
  '/me/security': typeof AuthMeSecurityRoute
  '/meetings/$meetingId': typeof AuthMeetingsMeetingIdRoute
  '/meetings/guest': typeof AuthMeetingsGuestRoute
  '/minutes/new': typeof AuthMinutesNewRoute
  '/o/$orgId': typeof AuthOOrgIdRouteWithChildren
  '/s/$spaceId': typeof AuthSSpaceIdRouteWithChildren
  '/meetings/join/$token': typeof MeetingsJoinTokenRoute
  '/me/': typeof AuthMeIndexRoute
  '/spaces/': typeof AuthSpacesIndexRoute
  '/minutes/$spaceId/$minutesId': typeof AuthMinutesSpaceIdMinutesIdRoute
  '/o/$orgId/activity': typeof AuthOOrgIdActivityRoute
  '/o/$orgId/admin': typeof AuthOOrgIdAdminRouteWithChildren
  '/o/$orgId/calendar': typeof AuthOOrgIdCalendarRoute
  '/o/$orgId/directory': typeof AuthOOrgIdDirectoryRoute
  '/o/$orgId/files': typeof AuthOOrgIdFilesRoute
  '/o/$orgId/finance': typeof AuthOOrgIdFinanceRouteWithChildren
  '/o/$orgId/more': typeof AuthOOrgIdMoreRoute
  '/o/$orgId/partnerships': typeof AuthOOrgIdPartnershipsRoute
  '/o/$orgId/search': typeof AuthOOrgIdSearchRoute
  '/o/$orgId/space-approvals': typeof AuthOOrgIdSpaceApprovalsRoute
  '/o/$orgId/timesheets': typeof AuthOOrgIdTimesheetsRoute
  '/s/$spaceId/$tab': typeof AuthSSpaceIdTabRoute
  '/o/$orgId/': typeof AuthOOrgIdIndexRoute
  '/s/$spaceId/': typeof AuthSSpaceIdIndexRoute
  '/o/$orgId/admin/audit': typeof AuthOOrgIdAdminAuditRoute
  '/o/$orgId/admin/checklists': typeof AuthOOrgIdAdminChecklistsRoute
  '/o/$orgId/admin/data': typeof AuthOOrgIdAdminDataRoute
  '/o/$orgId/admin/documents': typeof AuthOOrgIdAdminDocumentsRoute
  '/o/$orgId/admin/fiscal': typeof AuthOOrgIdAdminFiscalRoute
  '/o/$orgId/admin/members': typeof AuthOOrgIdAdminMembersRoute
  '/o/$orgId/admin/policies': typeof AuthOOrgIdAdminPoliciesRoute
  '/o/$orgId/admin/profile': typeof AuthOOrgIdAdminProfileRoute
  '/o/$orgId/admin/roles': typeof AuthOOrgIdAdminRolesRoute
  '/o/$orgId/admin/storage': typeof AuthOOrgIdAdminStorageRoute
  '/o/$orgId/admin/subscription': typeof AuthOOrgIdAdminSubscriptionRoute
  '/o/$orgId/admin/templates': typeof AuthOOrgIdAdminTemplatesRoute
  '/o/$orgId/chat/$channelId': typeof AuthOOrgIdChatChannelIdRoute
  '/o/$orgId/clients/$clientId': typeof AuthOOrgIdClientsClientIdRoute
  '/o/$orgId/finance/accounting': typeof AuthOOrgIdFinanceAccountingRoute
  '/o/$orgId/finance/cost-rates': typeof AuthOOrgIdFinanceCostRatesRoute
  '/o/$orgId/finance/dashboard': typeof AuthOOrgIdFinanceDashboardRoute
  '/o/$orgId/finance/einvoicing': typeof AuthOOrgIdFinanceEinvoicingRoute
  '/o/$orgId/finance/management': typeof AuthOOrgIdFinanceManagementRoute
  '/o/$orgId/finance/payments': typeof AuthOOrgIdFinancePaymentsRoute
  '/o/$orgId/finance/profitability': typeof AuthOOrgIdFinanceProfitabilityRoute
  '/o/$orgId/finance/supplier-invoices': typeof AuthOOrgIdFinanceSupplierInvoicesRoute
  '/o/$orgId/finance/suppliers': typeof AuthOOrgIdFinanceSuppliersRoute
  '/o/$orgId/finance/treasury': typeof AuthOOrgIdFinanceTreasuryRoute
  '/o/$orgId/finance/withholding': typeof AuthOOrgIdFinanceWithholdingRoute
  '/o/$orgId/meetings/$meetingId': typeof AuthOOrgIdMeetingsMeetingIdRoute
  '/o/$orgId/signatures/$requestId': typeof AuthOOrgIdSignaturesRequestIdRoute
  '/o/$orgId/tenders/$tenderId': typeof AuthOOrgIdTendersTenderIdRoute
  '/o/$orgId/tenders/vault': typeof AuthOOrgIdTendersVaultRoute
  '/o/$orgId/admin/': typeof AuthOOrgIdAdminIndexRoute
  '/o/$orgId/chat/': typeof AuthOOrgIdChatIndexRoute
  '/o/$orgId/clients/': typeof AuthOOrgIdClientsIndexRoute
  '/o/$orgId/finance/': typeof AuthOOrgIdFinanceIndexRoute
  '/o/$orgId/projects/': typeof AuthOOrgIdProjectsIndexRoute
  '/o/$orgId/signatures/': typeof AuthOOrgIdSignaturesIndexRoute
  '/o/$orgId/tenders/': typeof AuthOOrgIdTendersIndexRoute
  '/o/$orgId/finance/contracts/new': typeof AuthOOrgIdFinanceContractsNewRoute
  '/o/$orgId/finance/expenses/approvals': typeof AuthOOrgIdFinanceExpensesApprovalsRoute
  '/o/$orgId/finance/invoices/$invoiceId': typeof AuthOOrgIdFinanceInvoicesInvoiceIdRoute
  '/o/$orgId/finance/invoices/new': typeof AuthOOrgIdFinanceInvoicesNewRoute
  '/o/$orgId/finance/quotes/$quoteId': typeof AuthOOrgIdFinanceQuotesQuoteIdRoute
  '/o/$orgId/finance/quotes/new': typeof AuthOOrgIdFinanceQuotesNewRoute
  '/o/$orgId/projects/$projectId/$tab': typeof AuthOOrgIdProjectsProjectIdTabRoute
  '/o/$orgId/finance/contracts/': typeof AuthOOrgIdFinanceContractsIndexRoute
  '/o/$orgId/finance/expenses/': typeof AuthOOrgIdFinanceExpensesIndexRoute
  '/o/$orgId/finance/invoices/': typeof AuthOOrgIdFinanceInvoicesIndexRoute
  '/o/$orgId/finance/quotes/': typeof AuthOOrgIdFinanceQuotesIndexRoute
  '/o/$orgId/projects/$projectId/': typeof AuthOOrgIdProjectsProjectIdIndexRoute
  '/o/$orgId/finance/contracts/$contractId/progress': typeof AuthOOrgIdFinanceContractsContractIdProgressRoute
  '/o/$orgId/projects/$projectId/documents/$documentId': typeof AuthOOrgIdProjectsProjectIdDocumentsDocumentIdRoute
  '/o/$orgId/projects/$projectId/workspace/$section': typeof AuthOOrgIdProjectsProjectIdWorkspaceSectionRoute
  '/o/$orgId/finance/contracts/$contractId/': typeof AuthOOrgIdFinanceContractsContractIdIndexRoute
}
export interface FileRoutesByTo {
  '/signed-out': typeof SignedOutRoute
  '/onboarding': typeof AuthOnboardingRoute
  '/invitations/$token': typeof InvitationsTokenRoute
  '/invitations/accept': typeof InvitationsAcceptRoute
  '/l/$token': typeof LTokenRoute
  '/q/$token': typeof QTokenRoute
  '/t/$token': typeof TTokenRoute
  '/': typeof AuthIndexRoute
  '/calls/$meetingId': typeof AuthCallsMeetingIdRoute
  '/invitations/spaces': typeof AuthInvitationsSpacesRoute
  '/me/notifications': typeof AuthMeNotificationsRoute
  '/me/profile': typeof AuthMeProfileRoute
  '/me/security': typeof AuthMeSecurityRoute
  '/meetings/$meetingId': typeof AuthMeetingsMeetingIdRoute
  '/meetings/guest': typeof AuthMeetingsGuestRoute
  '/minutes/new': typeof AuthMinutesNewRoute
  '/meetings/join/$token': typeof MeetingsJoinTokenRoute
  '/me': typeof AuthMeIndexRoute
  '/spaces': typeof AuthSpacesIndexRoute
  '/minutes/$spaceId/$minutesId': typeof AuthMinutesSpaceIdMinutesIdRoute
  '/o/$orgId/activity': typeof AuthOOrgIdActivityRoute
  '/o/$orgId/calendar': typeof AuthOOrgIdCalendarRoute
  '/o/$orgId/directory': typeof AuthOOrgIdDirectoryRoute
  '/o/$orgId/files': typeof AuthOOrgIdFilesRoute
  '/o/$orgId/more': typeof AuthOOrgIdMoreRoute
  '/o/$orgId/partnerships': typeof AuthOOrgIdPartnershipsRoute
  '/o/$orgId/search': typeof AuthOOrgIdSearchRoute
  '/o/$orgId/space-approvals': typeof AuthOOrgIdSpaceApprovalsRoute
  '/o/$orgId/timesheets': typeof AuthOOrgIdTimesheetsRoute
  '/s/$spaceId/$tab': typeof AuthSSpaceIdTabRoute
  '/o/$orgId': typeof AuthOOrgIdIndexRoute
  '/s/$spaceId': typeof AuthSSpaceIdIndexRoute
  '/o/$orgId/admin/audit': typeof AuthOOrgIdAdminAuditRoute
  '/o/$orgId/admin/checklists': typeof AuthOOrgIdAdminChecklistsRoute
  '/o/$orgId/admin/data': typeof AuthOOrgIdAdminDataRoute
  '/o/$orgId/admin/documents': typeof AuthOOrgIdAdminDocumentsRoute
  '/o/$orgId/admin/fiscal': typeof AuthOOrgIdAdminFiscalRoute
  '/o/$orgId/admin/members': typeof AuthOOrgIdAdminMembersRoute
  '/o/$orgId/admin/policies': typeof AuthOOrgIdAdminPoliciesRoute
  '/o/$orgId/admin/profile': typeof AuthOOrgIdAdminProfileRoute
  '/o/$orgId/admin/roles': typeof AuthOOrgIdAdminRolesRoute
  '/o/$orgId/admin/storage': typeof AuthOOrgIdAdminStorageRoute
  '/o/$orgId/admin/subscription': typeof AuthOOrgIdAdminSubscriptionRoute
  '/o/$orgId/admin/templates': typeof AuthOOrgIdAdminTemplatesRoute
  '/o/$orgId/chat/$channelId': typeof AuthOOrgIdChatChannelIdRoute
  '/o/$orgId/clients/$clientId': typeof AuthOOrgIdClientsClientIdRoute
  '/o/$orgId/finance/accounting': typeof AuthOOrgIdFinanceAccountingRoute
  '/o/$orgId/finance/cost-rates': typeof AuthOOrgIdFinanceCostRatesRoute
  '/o/$orgId/finance/dashboard': typeof AuthOOrgIdFinanceDashboardRoute
  '/o/$orgId/finance/einvoicing': typeof AuthOOrgIdFinanceEinvoicingRoute
  '/o/$orgId/finance/management': typeof AuthOOrgIdFinanceManagementRoute
  '/o/$orgId/finance/payments': typeof AuthOOrgIdFinancePaymentsRoute
  '/o/$orgId/finance/profitability': typeof AuthOOrgIdFinanceProfitabilityRoute
  '/o/$orgId/finance/supplier-invoices': typeof AuthOOrgIdFinanceSupplierInvoicesRoute
  '/o/$orgId/finance/suppliers': typeof AuthOOrgIdFinanceSuppliersRoute
  '/o/$orgId/finance/treasury': typeof AuthOOrgIdFinanceTreasuryRoute
  '/o/$orgId/finance/withholding': typeof AuthOOrgIdFinanceWithholdingRoute
  '/o/$orgId/meetings/$meetingId': typeof AuthOOrgIdMeetingsMeetingIdRoute
  '/o/$orgId/signatures/$requestId': typeof AuthOOrgIdSignaturesRequestIdRoute
  '/o/$orgId/tenders/$tenderId': typeof AuthOOrgIdTendersTenderIdRoute
  '/o/$orgId/tenders/vault': typeof AuthOOrgIdTendersVaultRoute
  '/o/$orgId/admin': typeof AuthOOrgIdAdminIndexRoute
  '/o/$orgId/chat': typeof AuthOOrgIdChatIndexRoute
  '/o/$orgId/clients': typeof AuthOOrgIdClientsIndexRoute
  '/o/$orgId/finance': typeof AuthOOrgIdFinanceIndexRoute
  '/o/$orgId/projects': typeof AuthOOrgIdProjectsIndexRoute
  '/o/$orgId/signatures': typeof AuthOOrgIdSignaturesIndexRoute
  '/o/$orgId/tenders': typeof AuthOOrgIdTendersIndexRoute
  '/o/$orgId/finance/contracts/new': typeof AuthOOrgIdFinanceContractsNewRoute
  '/o/$orgId/finance/expenses/approvals': typeof AuthOOrgIdFinanceExpensesApprovalsRoute
  '/o/$orgId/finance/invoices/$invoiceId': typeof AuthOOrgIdFinanceInvoicesInvoiceIdRoute
  '/o/$orgId/finance/invoices/new': typeof AuthOOrgIdFinanceInvoicesNewRoute
  '/o/$orgId/finance/quotes/$quoteId': typeof AuthOOrgIdFinanceQuotesQuoteIdRoute
  '/o/$orgId/finance/quotes/new': typeof AuthOOrgIdFinanceQuotesNewRoute
  '/o/$orgId/projects/$projectId/$tab': typeof AuthOOrgIdProjectsProjectIdTabRoute
  '/o/$orgId/finance/contracts': typeof AuthOOrgIdFinanceContractsIndexRoute
  '/o/$orgId/finance/expenses': typeof AuthOOrgIdFinanceExpensesIndexRoute
  '/o/$orgId/finance/invoices': typeof AuthOOrgIdFinanceInvoicesIndexRoute
  '/o/$orgId/finance/quotes': typeof AuthOOrgIdFinanceQuotesIndexRoute
  '/o/$orgId/projects/$projectId': typeof AuthOOrgIdProjectsProjectIdIndexRoute
  '/o/$orgId/finance/contracts/$contractId/progress': typeof AuthOOrgIdFinanceContractsContractIdProgressRoute
  '/o/$orgId/projects/$projectId/documents/$documentId': typeof AuthOOrgIdProjectsProjectIdDocumentsDocumentIdRoute
  '/o/$orgId/projects/$projectId/workspace/$section': typeof AuthOOrgIdProjectsProjectIdWorkspaceSectionRoute
  '/o/$orgId/finance/contracts/$contractId': typeof AuthOOrgIdFinanceContractsContractIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/signed-out': typeof SignedOutRoute
  '/_auth/me': typeof AuthMeRouteWithChildren
  '/_auth/onboarding': typeof AuthOnboardingRoute
  '/_auth/spaces': typeof AuthSpacesRouteWithChildren
  '/invitations/$token': typeof InvitationsTokenRoute
  '/invitations/accept': typeof InvitationsAcceptRoute
  '/l/$token': typeof LTokenRoute
  '/q/$token': typeof QTokenRoute
  '/t/$token': typeof TTokenRoute
  '/_auth/': typeof AuthIndexRoute
  '/_auth/calls/$meetingId': typeof AuthCallsMeetingIdRoute
  '/_auth/invitations/spaces': typeof AuthInvitationsSpacesRoute
  '/_auth/me/notifications': typeof AuthMeNotificationsRoute
  '/_auth/me/profile': typeof AuthMeProfileRoute
  '/_auth/me/security': typeof AuthMeSecurityRoute
  '/_auth/meetings/$meetingId': typeof AuthMeetingsMeetingIdRoute
  '/_auth/meetings/guest': typeof AuthMeetingsGuestRoute
  '/_auth/minutes/new': typeof AuthMinutesNewRoute
  '/_auth/o/$orgId': typeof AuthOOrgIdRouteWithChildren
  '/_auth/s/$spaceId': typeof AuthSSpaceIdRouteWithChildren
  '/meetings/join/$token': typeof MeetingsJoinTokenRoute
  '/_auth/me/': typeof AuthMeIndexRoute
  '/_auth/spaces/': typeof AuthSpacesIndexRoute
  '/_auth/minutes/$spaceId/$minutesId': typeof AuthMinutesSpaceIdMinutesIdRoute
  '/_auth/o/$orgId/activity': typeof AuthOOrgIdActivityRoute
  '/_auth/o/$orgId/admin': typeof AuthOOrgIdAdminRouteWithChildren
  '/_auth/o/$orgId/calendar': typeof AuthOOrgIdCalendarRoute
  '/_auth/o/$orgId/directory': typeof AuthOOrgIdDirectoryRoute
  '/_auth/o/$orgId/files': typeof AuthOOrgIdFilesRoute
  '/_auth/o/$orgId/finance': typeof AuthOOrgIdFinanceRouteWithChildren
  '/_auth/o/$orgId/more': typeof AuthOOrgIdMoreRoute
  '/_auth/o/$orgId/partnerships': typeof AuthOOrgIdPartnershipsRoute
  '/_auth/o/$orgId/search': typeof AuthOOrgIdSearchRoute
  '/_auth/o/$orgId/space-approvals': typeof AuthOOrgIdSpaceApprovalsRoute
  '/_auth/o/$orgId/timesheets': typeof AuthOOrgIdTimesheetsRoute
  '/_auth/s/$spaceId/$tab': typeof AuthSSpaceIdTabRoute
  '/_auth/o/$orgId/': typeof AuthOOrgIdIndexRoute
  '/_auth/s/$spaceId/': typeof AuthSSpaceIdIndexRoute
  '/_auth/o/$orgId/admin/audit': typeof AuthOOrgIdAdminAuditRoute
  '/_auth/o/$orgId/admin/checklists': typeof AuthOOrgIdAdminChecklistsRoute
  '/_auth/o/$orgId/admin/data': typeof AuthOOrgIdAdminDataRoute
  '/_auth/o/$orgId/admin/documents': typeof AuthOOrgIdAdminDocumentsRoute
  '/_auth/o/$orgId/admin/fiscal': typeof AuthOOrgIdAdminFiscalRoute
  '/_auth/o/$orgId/admin/members': typeof AuthOOrgIdAdminMembersRoute
  '/_auth/o/$orgId/admin/policies': typeof AuthOOrgIdAdminPoliciesRoute
  '/_auth/o/$orgId/admin/profile': typeof AuthOOrgIdAdminProfileRoute
  '/_auth/o/$orgId/admin/roles': typeof AuthOOrgIdAdminRolesRoute
  '/_auth/o/$orgId/admin/storage': typeof AuthOOrgIdAdminStorageRoute
  '/_auth/o/$orgId/admin/subscription': typeof AuthOOrgIdAdminSubscriptionRoute
  '/_auth/o/$orgId/admin/templates': typeof AuthOOrgIdAdminTemplatesRoute
  '/_auth/o/$orgId/chat/$channelId': typeof AuthOOrgIdChatChannelIdRoute
  '/_auth/o/$orgId/clients/$clientId': typeof AuthOOrgIdClientsClientIdRoute
  '/_auth/o/$orgId/finance/accounting': typeof AuthOOrgIdFinanceAccountingRoute
  '/_auth/o/$orgId/finance/cost-rates': typeof AuthOOrgIdFinanceCostRatesRoute
  '/_auth/o/$orgId/finance/dashboard': typeof AuthOOrgIdFinanceDashboardRoute
  '/_auth/o/$orgId/finance/einvoicing': typeof AuthOOrgIdFinanceEinvoicingRoute
  '/_auth/o/$orgId/finance/management': typeof AuthOOrgIdFinanceManagementRoute
  '/_auth/o/$orgId/finance/payments': typeof AuthOOrgIdFinancePaymentsRoute
  '/_auth/o/$orgId/finance/profitability': typeof AuthOOrgIdFinanceProfitabilityRoute
  '/_auth/o/$orgId/finance/supplier-invoices': typeof AuthOOrgIdFinanceSupplierInvoicesRoute
  '/_auth/o/$orgId/finance/suppliers': typeof AuthOOrgIdFinanceSuppliersRoute
  '/_auth/o/$orgId/finance/treasury': typeof AuthOOrgIdFinanceTreasuryRoute
  '/_auth/o/$orgId/finance/withholding': typeof AuthOOrgIdFinanceWithholdingRoute
  '/_auth/o/$orgId/meetings/$meetingId': typeof AuthOOrgIdMeetingsMeetingIdRoute
  '/_auth/o/$orgId/signatures/$requestId': typeof AuthOOrgIdSignaturesRequestIdRoute
  '/_auth/o/$orgId/tenders/$tenderId': typeof AuthOOrgIdTendersTenderIdRoute
  '/_auth/o/$orgId/tenders/vault': typeof AuthOOrgIdTendersVaultRoute
  '/_auth/o/$orgId/admin/': typeof AuthOOrgIdAdminIndexRoute
  '/_auth/o/$orgId/chat/': typeof AuthOOrgIdChatIndexRoute
  '/_auth/o/$orgId/clients/': typeof AuthOOrgIdClientsIndexRoute
  '/_auth/o/$orgId/finance/': typeof AuthOOrgIdFinanceIndexRoute
  '/_auth/o/$orgId/projects/': typeof AuthOOrgIdProjectsIndexRoute
  '/_auth/o/$orgId/signatures/': typeof AuthOOrgIdSignaturesIndexRoute
  '/_auth/o/$orgId/tenders/': typeof AuthOOrgIdTendersIndexRoute
  '/_auth/o/$orgId/finance/contracts/new': typeof AuthOOrgIdFinanceContractsNewRoute
  '/_auth/o/$orgId/finance/expenses/approvals': typeof AuthOOrgIdFinanceExpensesApprovalsRoute
  '/_auth/o/$orgId/finance/invoices/$invoiceId': typeof AuthOOrgIdFinanceInvoicesInvoiceIdRoute
  '/_auth/o/$orgId/finance/invoices/new': typeof AuthOOrgIdFinanceInvoicesNewRoute
  '/_auth/o/$orgId/finance/quotes/$quoteId': typeof AuthOOrgIdFinanceQuotesQuoteIdRoute
  '/_auth/o/$orgId/finance/quotes/new': typeof AuthOOrgIdFinanceQuotesNewRoute
  '/_auth/o/$orgId/projects/$projectId/$tab': typeof AuthOOrgIdProjectsProjectIdTabRoute
  '/_auth/o/$orgId/finance/contracts/': typeof AuthOOrgIdFinanceContractsIndexRoute
  '/_auth/o/$orgId/finance/expenses/': typeof AuthOOrgIdFinanceExpensesIndexRoute
  '/_auth/o/$orgId/finance/invoices/': typeof AuthOOrgIdFinanceInvoicesIndexRoute
  '/_auth/o/$orgId/finance/quotes/': typeof AuthOOrgIdFinanceQuotesIndexRoute
  '/_auth/o/$orgId/projects/$projectId/': typeof AuthOOrgIdProjectsProjectIdIndexRoute
  '/_auth/o/$orgId/finance/contracts/$contractId/progress': typeof AuthOOrgIdFinanceContractsContractIdProgressRoute
  '/_auth/o/$orgId/projects/$projectId/documents/$documentId': typeof AuthOOrgIdProjectsProjectIdDocumentsDocumentIdRoute
  '/_auth/o/$orgId/projects/$projectId/workspace/$section': typeof AuthOOrgIdProjectsProjectIdWorkspaceSectionRoute
  '/_auth/o/$orgId/finance/contracts/$contractId/': typeof AuthOOrgIdFinanceContractsContractIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/signed-out'
    | '/me'
    | '/onboarding'
    | '/spaces'
    | '/invitations/$token'
    | '/invitations/accept'
    | '/l/$token'
    | '/q/$token'
    | '/t/$token'
    | '/calls/$meetingId'
    | '/invitations/spaces'
    | '/me/notifications'
    | '/me/profile'
    | '/me/security'
    | '/meetings/$meetingId'
    | '/meetings/guest'
    | '/minutes/new'
    | '/o/$orgId'
    | '/s/$spaceId'
    | '/meetings/join/$token'
    | '/me/'
    | '/spaces/'
    | '/minutes/$spaceId/$minutesId'
    | '/o/$orgId/activity'
    | '/o/$orgId/admin'
    | '/o/$orgId/calendar'
    | '/o/$orgId/directory'
    | '/o/$orgId/files'
    | '/o/$orgId/finance'
    | '/o/$orgId/more'
    | '/o/$orgId/partnerships'
    | '/o/$orgId/search'
    | '/o/$orgId/space-approvals'
    | '/o/$orgId/timesheets'
    | '/s/$spaceId/$tab'
    | '/o/$orgId/'
    | '/s/$spaceId/'
    | '/o/$orgId/admin/audit'
    | '/o/$orgId/admin/checklists'
    | '/o/$orgId/admin/data'
    | '/o/$orgId/admin/documents'
    | '/o/$orgId/admin/fiscal'
    | '/o/$orgId/admin/members'
    | '/o/$orgId/admin/policies'
    | '/o/$orgId/admin/profile'
    | '/o/$orgId/admin/roles'
    | '/o/$orgId/admin/storage'
    | '/o/$orgId/admin/subscription'
    | '/o/$orgId/admin/templates'
    | '/o/$orgId/chat/$channelId'
    | '/o/$orgId/clients/$clientId'
    | '/o/$orgId/finance/accounting'
    | '/o/$orgId/finance/cost-rates'
    | '/o/$orgId/finance/dashboard'
    | '/o/$orgId/finance/einvoicing'
    | '/o/$orgId/finance/management'
    | '/o/$orgId/finance/payments'
    | '/o/$orgId/finance/profitability'
    | '/o/$orgId/finance/supplier-invoices'
    | '/o/$orgId/finance/suppliers'
    | '/o/$orgId/finance/treasury'
    | '/o/$orgId/finance/withholding'
    | '/o/$orgId/meetings/$meetingId'
    | '/o/$orgId/signatures/$requestId'
    | '/o/$orgId/tenders/$tenderId'
    | '/o/$orgId/tenders/vault'
    | '/o/$orgId/admin/'
    | '/o/$orgId/chat/'
    | '/o/$orgId/clients/'
    | '/o/$orgId/finance/'
    | '/o/$orgId/projects/'
    | '/o/$orgId/signatures/'
    | '/o/$orgId/tenders/'
    | '/o/$orgId/finance/contracts/new'
    | '/o/$orgId/finance/expenses/approvals'
    | '/o/$orgId/finance/invoices/$invoiceId'
    | '/o/$orgId/finance/invoices/new'
    | '/o/$orgId/finance/quotes/$quoteId'
    | '/o/$orgId/finance/quotes/new'
    | '/o/$orgId/projects/$projectId/$tab'
    | '/o/$orgId/finance/contracts/'
    | '/o/$orgId/finance/expenses/'
    | '/o/$orgId/finance/invoices/'
    | '/o/$orgId/finance/quotes/'
    | '/o/$orgId/projects/$projectId/'
    | '/o/$orgId/finance/contracts/$contractId/progress'
    | '/o/$orgId/projects/$projectId/documents/$documentId'
    | '/o/$orgId/projects/$projectId/workspace/$section'
    | '/o/$orgId/finance/contracts/$contractId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/signed-out'
    | '/onboarding'
    | '/invitations/$token'
    | '/invitations/accept'
    | '/l/$token'
    | '/q/$token'
    | '/t/$token'
    | '/'
    | '/calls/$meetingId'
    | '/invitations/spaces'
    | '/me/notifications'
    | '/me/profile'
    | '/me/security'
    | '/meetings/$meetingId'
    | '/meetings/guest'
    | '/minutes/new'
    | '/meetings/join/$token'
    | '/me'
    | '/spaces'
    | '/minutes/$spaceId/$minutesId'
    | '/o/$orgId/activity'
    | '/o/$orgId/calendar'
    | '/o/$orgId/directory'
    | '/o/$orgId/files'
    | '/o/$orgId/more'
    | '/o/$orgId/partnerships'
    | '/o/$orgId/search'
    | '/o/$orgId/space-approvals'
    | '/o/$orgId/timesheets'
    | '/s/$spaceId/$tab'
    | '/o/$orgId'
    | '/s/$spaceId'
    | '/o/$orgId/admin/audit'
    | '/o/$orgId/admin/checklists'
    | '/o/$orgId/admin/data'
    | '/o/$orgId/admin/documents'
    | '/o/$orgId/admin/fiscal'
    | '/o/$orgId/admin/members'
    | '/o/$orgId/admin/policies'
    | '/o/$orgId/admin/profile'
    | '/o/$orgId/admin/roles'
    | '/o/$orgId/admin/storage'
    | '/o/$orgId/admin/subscription'
    | '/o/$orgId/admin/templates'
    | '/o/$orgId/chat/$channelId'
    | '/o/$orgId/clients/$clientId'
    | '/o/$orgId/finance/accounting'
    | '/o/$orgId/finance/cost-rates'
    | '/o/$orgId/finance/dashboard'
    | '/o/$orgId/finance/einvoicing'
    | '/o/$orgId/finance/management'
    | '/o/$orgId/finance/payments'
    | '/o/$orgId/finance/profitability'
    | '/o/$orgId/finance/supplier-invoices'
    | '/o/$orgId/finance/suppliers'
    | '/o/$orgId/finance/treasury'
    | '/o/$orgId/finance/withholding'
    | '/o/$orgId/meetings/$meetingId'
    | '/o/$orgId/signatures/$requestId'
    | '/o/$orgId/tenders/$tenderId'
    | '/o/$orgId/tenders/vault'
    | '/o/$orgId/admin'
    | '/o/$orgId/chat'
    | '/o/$orgId/clients'
    | '/o/$orgId/finance'
    | '/o/$orgId/projects'
    | '/o/$orgId/signatures'
    | '/o/$orgId/tenders'
    | '/o/$orgId/finance/contracts/new'
    | '/o/$orgId/finance/expenses/approvals'
    | '/o/$orgId/finance/invoices/$invoiceId'
    | '/o/$orgId/finance/invoices/new'
    | '/o/$orgId/finance/quotes/$quoteId'
    | '/o/$orgId/finance/quotes/new'
    | '/o/$orgId/projects/$projectId/$tab'
    | '/o/$orgId/finance/contracts'
    | '/o/$orgId/finance/expenses'
    | '/o/$orgId/finance/invoices'
    | '/o/$orgId/finance/quotes'
    | '/o/$orgId/projects/$projectId'
    | '/o/$orgId/finance/contracts/$contractId/progress'
    | '/o/$orgId/projects/$projectId/documents/$documentId'
    | '/o/$orgId/projects/$projectId/workspace/$section'
    | '/o/$orgId/finance/contracts/$contractId'
  id:
    | '__root__'
    | '/_auth'
    | '/signed-out'
    | '/_auth/me'
    | '/_auth/onboarding'
    | '/_auth/spaces'
    | '/invitations/$token'
    | '/invitations/accept'
    | '/l/$token'
    | '/q/$token'
    | '/t/$token'
    | '/_auth/'
    | '/_auth/calls/$meetingId'
    | '/_auth/invitations/spaces'
    | '/_auth/me/notifications'
    | '/_auth/me/profile'
    | '/_auth/me/security'
    | '/_auth/meetings/$meetingId'
    | '/_auth/meetings/guest'
    | '/_auth/minutes/new'
    | '/_auth/o/$orgId'
    | '/_auth/s/$spaceId'
    | '/meetings/join/$token'
    | '/_auth/me/'
    | '/_auth/spaces/'
    | '/_auth/minutes/$spaceId/$minutesId'
    | '/_auth/o/$orgId/activity'
    | '/_auth/o/$orgId/admin'
    | '/_auth/o/$orgId/calendar'
    | '/_auth/o/$orgId/directory'
    | '/_auth/o/$orgId/files'
    | '/_auth/o/$orgId/finance'
    | '/_auth/o/$orgId/more'
    | '/_auth/o/$orgId/partnerships'
    | '/_auth/o/$orgId/search'
    | '/_auth/o/$orgId/space-approvals'
    | '/_auth/o/$orgId/timesheets'
    | '/_auth/s/$spaceId/$tab'
    | '/_auth/o/$orgId/'
    | '/_auth/s/$spaceId/'
    | '/_auth/o/$orgId/admin/audit'
    | '/_auth/o/$orgId/admin/checklists'
    | '/_auth/o/$orgId/admin/data'
    | '/_auth/o/$orgId/admin/documents'
    | '/_auth/o/$orgId/admin/fiscal'
    | '/_auth/o/$orgId/admin/members'
    | '/_auth/o/$orgId/admin/policies'
    | '/_auth/o/$orgId/admin/profile'
    | '/_auth/o/$orgId/admin/roles'
    | '/_auth/o/$orgId/admin/storage'
    | '/_auth/o/$orgId/admin/subscription'
    | '/_auth/o/$orgId/admin/templates'
    | '/_auth/o/$orgId/chat/$channelId'
    | '/_auth/o/$orgId/clients/$clientId'
    | '/_auth/o/$orgId/finance/accounting'
    | '/_auth/o/$orgId/finance/cost-rates'
    | '/_auth/o/$orgId/finance/dashboard'
    | '/_auth/o/$orgId/finance/einvoicing'
    | '/_auth/o/$orgId/finance/management'
    | '/_auth/o/$orgId/finance/payments'
    | '/_auth/o/$orgId/finance/profitability'
    | '/_auth/o/$orgId/finance/supplier-invoices'
    | '/_auth/o/$orgId/finance/suppliers'
    | '/_auth/o/$orgId/finance/treasury'
    | '/_auth/o/$orgId/finance/withholding'
    | '/_auth/o/$orgId/meetings/$meetingId'
    | '/_auth/o/$orgId/signatures/$requestId'
    | '/_auth/o/$orgId/tenders/$tenderId'
    | '/_auth/o/$orgId/tenders/vault'
    | '/_auth/o/$orgId/admin/'
    | '/_auth/o/$orgId/chat/'
    | '/_auth/o/$orgId/clients/'
    | '/_auth/o/$orgId/finance/'
    | '/_auth/o/$orgId/projects/'
    | '/_auth/o/$orgId/signatures/'
    | '/_auth/o/$orgId/tenders/'
    | '/_auth/o/$orgId/finance/contracts/new'
    | '/_auth/o/$orgId/finance/expenses/approvals'
    | '/_auth/o/$orgId/finance/invoices/$invoiceId'
    | '/_auth/o/$orgId/finance/invoices/new'
    | '/_auth/o/$orgId/finance/quotes/$quoteId'
    | '/_auth/o/$orgId/finance/quotes/new'
    | '/_auth/o/$orgId/projects/$projectId/$tab'
    | '/_auth/o/$orgId/finance/contracts/'
    | '/_auth/o/$orgId/finance/expenses/'
    | '/_auth/o/$orgId/finance/invoices/'
    | '/_auth/o/$orgId/finance/quotes/'
    | '/_auth/o/$orgId/projects/$projectId/'
    | '/_auth/o/$orgId/finance/contracts/$contractId/progress'
    | '/_auth/o/$orgId/projects/$projectId/documents/$documentId'
    | '/_auth/o/$orgId/projects/$projectId/workspace/$section'
    | '/_auth/o/$orgId/finance/contracts/$contractId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  SignedOutRoute: typeof SignedOutRoute
  InvitationsTokenRoute: typeof InvitationsTokenRoute
  InvitationsAcceptRoute: typeof InvitationsAcceptRoute
  LTokenRoute: typeof LTokenRoute
  QTokenRoute: typeof QTokenRoute
  TTokenRoute: typeof TTokenRoute
  MeetingsJoinTokenRoute: typeof MeetingsJoinTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signed-out': {
      id: '/signed-out'
      path: '/signed-out'
      fullPath: '/signed-out'
      preLoaderRoute: typeof SignedOutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/me': {
      id: '/_auth/me'
      path: '/me'
      fullPath: '/me'
      preLoaderRoute: typeof AuthMeRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/onboarding': {
      id: '/_auth/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AuthOnboardingRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/spaces': {
      id: '/_auth/spaces'
      path: '/spaces'
      fullPath: '/spaces'
      preLoaderRoute: typeof AuthSpacesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/invitations/$token': {
      id: '/invitations/$token'
      path: '/invitations/$token'
      fullPath: '/invitations/$token'
      preLoaderRoute: typeof InvitationsTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invitations/accept': {
      id: '/invitations/accept'
      path: '/invitations/accept'
      fullPath: '/invitations/accept'
      preLoaderRoute: typeof InvitationsAcceptRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/l/$token': {
      id: '/l/$token'
      path: '/l/$token'
      fullPath: '/l/$token'
      preLoaderRoute: typeof LTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/q/$token': {
      id: '/q/$token'
      path: '/q/$token'
      fullPath: '/q/$token'
      preLoaderRoute: typeof QTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/t/$token': {
      id: '/t/$token'
      path: '/t/$token'
      fullPath: '/t/$token'
      preLoaderRoute: typeof TTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/calls/$meetingId': {
      id: '/_auth/calls/$meetingId'
      path: '/calls/$meetingId'
      fullPath: '/calls/$meetingId'
      preLoaderRoute: typeof AuthCallsMeetingIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/invitations/spaces': {
      id: '/_auth/invitations/spaces'
      path: '/invitations/spaces'
      fullPath: '/invitations/spaces'
      preLoaderRoute: typeof AuthInvitationsSpacesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/me/': {
      id: '/_auth/me/'
      path: '/'
      fullPath: '/me/'
      preLoaderRoute: typeof AuthMeIndexRouteImport
      parentRoute: typeof AuthMeRoute
    }
    '/_auth/me/notifications': {
      id: '/_auth/me/notifications'
      path: '/notifications'
      fullPath: '/me/notifications'
      preLoaderRoute: typeof AuthMeNotificationsRouteImport
      parentRoute: typeof AuthMeRoute
    }
    '/_auth/me/profile': {
      id: '/_auth/me/profile'
      path: '/profile'
      fullPath: '/me/profile'
      preLoaderRoute: typeof AuthMeProfileRouteImport
      parentRoute: typeof AuthMeRoute
    }
    '/_auth/me/security': {
      id: '/_auth/me/security'
      path: '/security'
      fullPath: '/me/security'
      preLoaderRoute: typeof AuthMeSecurityRouteImport
      parentRoute: typeof AuthMeRoute
    }
    '/_auth/meetings/$meetingId': {
      id: '/_auth/meetings/$meetingId'
      path: '/meetings/$meetingId'
      fullPath: '/meetings/$meetingId'
      preLoaderRoute: typeof AuthMeetingsMeetingIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/meetings/guest': {
      id: '/_auth/meetings/guest'
      path: '/meetings/guest'
      fullPath: '/meetings/guest'
      preLoaderRoute: typeof AuthMeetingsGuestRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/minutes/new': {
      id: '/_auth/minutes/new'
      path: '/minutes/new'
      fullPath: '/minutes/new'
      preLoaderRoute: typeof AuthMinutesNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/o/$orgId': {
      id: '/_auth/o/$orgId'
      path: '/o/$orgId'
      fullPath: '/o/$orgId'
      preLoaderRoute: typeof AuthOOrgIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/s/$spaceId': {
      id: '/_auth/s/$spaceId'
      path: '/s/$spaceId'
      fullPath: '/s/$spaceId'
      preLoaderRoute: typeof AuthSSpaceIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/spaces/': {
      id: '/_auth/spaces/'
      path: '/'
      fullPath: '/spaces/'
      preLoaderRoute: typeof AuthSpacesIndexRouteImport
      parentRoute: typeof AuthSpacesRoute
    }
    '/meetings/join/$token': {
      id: '/meetings/join/$token'
      path: '/meetings/join/$token'
      fullPath: '/meetings/join/$token'
      preLoaderRoute: typeof MeetingsJoinTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/minutes/$spaceId/$minutesId': {
      id: '/_auth/minutes/$spaceId/$minutesId'
      path: '/minutes/$spaceId/$minutesId'
      fullPath: '/minutes/$spaceId/$minutesId'
      preLoaderRoute: typeof AuthMinutesSpaceIdMinutesIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/o/$orgId/': {
      id: '/_auth/o/$orgId/'
      path: '/'
      fullPath: '/o/$orgId/'
      preLoaderRoute: typeof AuthOOrgIdIndexRouteImport
      parentRoute: typeof AuthOOrgIdRoute
    }
    '/_auth/o/$orgId/activity': {
      id: '/_auth/o/$orgId/activity'
      path: '/activity'
      fullPath: '/o/$orgId/activity'
      preLoaderRoute: typeof AuthOOrgIdActivityRouteImport
      parentRoute: typeof AuthOOrgIdRoute
    }
    '/_auth/o/$orgId/admin': {
      id: '/_auth/o/$orgId/admin'
      path: '/admin'
      fullPath: '/o/$orgId/admin'
      preLoaderRoute: typeof AuthOOrgIdAdminRouteImport
      parentRoute: typeof AuthOOrgIdRoute
    }
    '/_auth/o/$orgId/calendar': {
      id: '/_auth/o/$orgId/calendar'
      path: '/calendar'
      fullPath: '/o/$orgId/calendar'
      preLoaderRoute: typeof AuthOOrgIdCalendarRouteImport
      parentRoute: typeof AuthOOrgIdRoute
    }
    '/_auth/o/$orgId/directory': {
      id: '/_auth/o/$orgId/directory'
      path: '/directory'
      fullPath: '/o/$orgId/directory'
      preLoaderRoute: typeof AuthOOrgIdDirectoryRouteImport
      parentRoute: typeof AuthOOrgIdRoute
    }
    '/_auth/o/$orgId/files': {
      id: '/_auth/o/$orgId/files'
      path: '/files'
      fullPath: '/o/$orgId/files'
      preLoaderRoute: typeof AuthOOrgIdFilesRouteImport
      parentRoute: typeof AuthOOrgIdRoute
    }
    '/_auth/o/$orgId/finance': {
      id: '/_auth/o/$orgId/finance'
      path: '/finance'
      fullPath: '/o/$orgId/finance'
      preLoaderRoute: typeof AuthOOrgIdFinanceRouteImport
      parentRoute: typeof AuthOOrgIdRoute
    }
    '/_auth/o/$orgId/more': {
      id: '/_auth/o/$orgId/more'
      path: '/more'
      fullPath: '/o/$orgId/more'
      preLoaderRoute: typeof AuthOOrgIdMoreRouteImport
      parentRoute: typeof AuthOOrgIdRoute
    }
    '/_auth/o/$orgId/partnerships': {
      id: '/_auth/o/$orgId/partnerships'
      path: '/partnerships'
      fullPath: '/o/$orgId/partnerships'
      preLoaderRoute: typeof AuthOOrgIdPartnershipsRouteImport
      parentRoute: typeof AuthOOrgIdRoute
    }
    '/_auth/o/$orgId/search': {
      id: '/_auth/o/$orgId/search'
      path: '/search'
      fullPath: '/o/$orgId/search'
      preLoaderRoute: typeof AuthOOrgIdSearchRouteImport
      parentRoute: typeof AuthOOrgIdRoute
    }
    '/_auth/o/$orgId/space-approvals': {
      id: '/_auth/o/$orgId/space-approvals'
      path: '/space-approvals'
      fullPath: '/o/$orgId/space-approvals'
      preLoaderRoute: typeof AuthOOrgIdSpaceApprovalsRouteImport
      parentRoute: typeof AuthOOrgIdRoute
    }
    '/_auth/o/$orgId/timesheets': {
      id: '/_auth/o/$orgId/timesheets'
      path: '/timesheets'
      fullPath: '/o/$orgId/timesheets'
      preLoaderRoute: typeof AuthOOrgIdTimesheetsRouteImport
      parentRoute: typeof AuthOOrgIdRoute
    }
    '/_auth/s/$spaceId/': {
      id: '/_auth/s/$spaceId/'
      path: '/'
      fullPath: '/s/$spaceId/'
      preLoaderRoute: typeof AuthSSpaceIdIndexRouteImport
      parentRoute: typeof AuthSSpaceIdRoute
    }
    '/_auth/s/$spaceId/$tab': {
      id: '/_auth/s/$spaceId/$tab'
      path: '/$tab'
      fullPath: '/s/$spaceId/$tab'
      preLoaderRoute: typeof AuthSSpaceIdTabRouteImport
      parentRoute: typeof AuthSSpaceIdRoute
    }
    '/_auth/o/$orgId/admin/': {
      id: '/_auth/o/$orgId/admin/'
      path: '/'
      fullPath: '/o/$orgId/admin/'
      preLoaderRoute: typeof AuthOOrgIdAdminIndexRouteImport
      parentRoute: typeof AuthOOrgIdAdminRoute
    }
    '/_auth/o/$orgId/admin/audit': {
      id: '/_auth/o/$orgId/admin/audit'
      path: '/audit'
      fullPath: '/o/$orgId/admin/audit'
      preLoaderRoute: typeof AuthOOrgIdAdminAuditRouteImport
      parentRoute: typeof AuthOOrgIdAdminRoute
    }
    '/_auth/o/$orgId/admin/checklists': {
      id: '/_auth/o/$orgId/admin/checklists'
      path: '/checklists'
      fullPath: '/o/$orgId/admin/checklists'
      preLoaderRoute: typeof AuthOOrgIdAdminChecklistsRouteImport
      parentRoute: typeof AuthOOrgIdAdminRoute
    }
    '/_auth/o/$orgId/admin/data': {
      id: '/_auth/o/$orgId/admin/data'
      path: '/data'
      fullPath: '/o/$orgId/admin/data'
      preLoaderRoute: typeof AuthOOrgIdAdminDataRouteImport
      parentRoute: typeof AuthOOrgIdAdminRoute
    }
    '/_auth/o/$orgId/admin/documents': {
      id: '/_auth/o/$orgId/admin/documents'
      path: '/documents'
      fullPath: '/o/$orgId/admin/documents'
      preLoaderRoute: typeof AuthOOrgIdAdminDocumentsRouteImport
      parentRoute: typeof AuthOOrgIdAdminRoute
    }
    '/_auth/o/$orgId/admin/fiscal': {
      id: '/_auth/o/$orgId/admin/fiscal'
      path: '/fiscal'
      fullPath: '/o/$orgId/admin/fiscal'
      preLoaderRoute: typeof AuthOOrgIdAdminFiscalRouteImport
      parentRoute: typeof AuthOOrgIdAdminRoute
    }
    '/_auth/o/$orgId/admin/members': {
      id: '/_auth/o/$orgId/admin/members'
      path: '/members'
      fullPath: '/o/$orgId/admin/members'
      preLoaderRoute: typeof AuthOOrgIdAdminMembersRouteImport
      parentRoute: typeof AuthOOrgIdAdminRoute
    }
    '/_auth/o/$orgId/admin/policies': {
      id: '/_auth/o/$orgId/admin/policies'
      path: '/policies'
      fullPath: '/o/$orgId/admin/policies'
      preLoaderRoute: typeof AuthOOrgIdAdminPoliciesRouteImport
      parentRoute: typeof AuthOOrgIdAdminRoute
    }
    '/_auth/o/$orgId/admin/profile': {
      id: '/_auth/o/$orgId/admin/profile'
      path: '/profile'
      fullPath: '/o/$orgId/admin/profile'
      preLoaderRoute: typeof AuthOOrgIdAdminProfileRouteImport
      parentRoute: typeof AuthOOrgIdAdminRoute
    }
    '/_auth/o/$orgId/admin/roles': {
      id: '/_auth/o/$orgId/admin/roles'
      path: '/roles'
      fullPath: '/o/$orgId/admin/roles'
      preLoaderRoute: typeof AuthOOrgIdAdminRolesRouteImport
      parentRoute: typeof AuthOOrgIdAdminRoute
    }
    '/_auth/o/$orgId/admin/storage': {
      id: '/_auth/o/$orgId/admin/storage'
      path: '/storage'
      fullPath: '/o/$orgId/admin/storage'
      preLoaderRoute: typeof AuthOOrgIdAdminStorageRouteImport
      parentRoute: typeof AuthOOrgIdAdminRoute
    }
    '/_auth/o/$orgId/admin/subscription': {
      id: '/_auth/o/$orgId/admin/subscription'
      path: '/subscription'
      fullPath: '/o/$orgId/admin/subscription'
      preLoaderRoute: typeof AuthOOrgIdAdminSubscriptionRouteImport
      parentRoute: typeof AuthOOrgIdAdminRoute
    }
    '/_auth/o/$orgId/admin/templates': {
      id: '/_auth/o/$orgId/admin/templates'
      path: '/templates'
      fullPath: '/o/$orgId/admin/templates'
      preLoaderRoute: typeof AuthOOrgIdAdminTemplatesRouteImport
      parentRoute: typeof AuthOOrgIdAdminRoute
    }
    '/_auth/o/$orgId/chat/': {
      id: '/_auth/o/$orgId/chat/'
      path: '/chat'
      fullPath: '/o/$orgId/chat/'
      preLoaderRoute: typeof AuthOOrgIdChatIndexRouteImport
      parentRoute: typeof AuthOOrgIdRoute
    }
    '/_auth/o/$orgId/chat/$channelId': {
      id: '/_auth/o/$orgId/chat/$channelId'
      path: '/chat/$channelId'
      fullPath: '/o/$orgId/chat/$channelId'
      preLoaderRoute: typeof AuthOOrgIdChatChannelIdRouteImport
      parentRoute: typeof AuthOOrgIdRoute
    }
    '/_auth/o/$orgId/clients/': {
      id: '/_auth/o/$orgId/clients/'
      path: '/clients'
      fullPath: '/o/$orgId/clients/'
      preLoaderRoute: typeof AuthOOrgIdClientsIndexRouteImport
      parentRoute: typeof AuthOOrgIdRoute
    }
    '/_auth/o/$orgId/clients/$clientId': {
      id: '/_auth/o/$orgId/clients/$clientId'
      path: '/clients/$clientId'
      fullPath: '/o/$orgId/clients/$clientId'
      preLoaderRoute: typeof AuthOOrgIdClientsClientIdRouteImport
      parentRoute: typeof AuthOOrgIdRoute
    }
    '/_auth/o/$orgId/finance/': {
      id: '/_auth/o/$orgId/finance/'
      path: '/'
      fullPath: '/o/$orgId/finance/'
      preLoaderRoute: typeof AuthOOrgIdFinanceIndexRouteImport
      parentRoute: typeof AuthOOrgIdFinanceRoute
    }
    '/_auth/o/$orgId/finance/accounting': {
      id: '/_auth/o/$orgId/finance/accounting'
      path: '/accounting'
      fullPath: '/o/$orgId/finance/accounting'
      preLoaderRoute: typeof AuthOOrgIdFinanceAccountingRouteImport
      parentRoute: typeof AuthOOrgIdFinanceRoute
    }
    '/_auth/o/$orgId/finance/cost-rates': {
      id: '/_auth/o/$orgId/finance/cost-rates'
      path: '/cost-rates'
      fullPath: '/o/$orgId/finance/cost-rates'
      preLoaderRoute: typeof AuthOOrgIdFinanceCostRatesRouteImport
      parentRoute: typeof AuthOOrgIdFinanceRoute
    }
    '/_auth/o/$orgId/finance/dashboard': {
      id: '/_auth/o/$orgId/finance/dashboard'
      path: '/dashboard'
      fullPath: '/o/$orgId/finance/dashboard'
      preLoaderRoute: typeof AuthOOrgIdFinanceDashboardRouteImport
      parentRoute: typeof AuthOOrgIdFinanceRoute
    }
    '/_auth/o/$orgId/finance/einvoicing': {
      id: '/_auth/o/$orgId/finance/einvoicing'
      path: '/einvoicing'
      fullPath: '/o/$orgId/finance/einvoicing'
      preLoaderRoute: typeof AuthOOrgIdFinanceEinvoicingRouteImport
      parentRoute: typeof AuthOOrgIdFinanceRoute
    }
    '/_auth/o/$orgId/finance/management': {
      id: '/_auth/o/$orgId/finance/management'
      path: '/management'
      fullPath: '/o/$orgId/finance/management'
      preLoaderRoute: typeof AuthOOrgIdFinanceManagementRouteImport
      parentRoute: typeof AuthOOrgIdFinanceRoute
    }
    '/_auth/o/$orgId/finance/payments': {
      id: '/_auth/o/$orgId/finance/payments'
      path: '/payments'
      fullPath: '/o/$orgId/finance/payments'
      preLoaderRoute: typeof AuthOOrgIdFinancePaymentsRouteImport
      parentRoute: typeof AuthOOrgIdFinanceRoute
    }
    '/_auth/o/$orgId/finance/profitability': {
      id: '/_auth/o/$orgId/finance/profitability'
      path: '/profitability'
      fullPath: '/o/$orgId/finance/profitability'
      preLoaderRoute: typeof AuthOOrgIdFinanceProfitabilityRouteImport
      parentRoute: typeof AuthOOrgIdFinanceRoute
    }
    '/_auth/o/$orgId/finance/supplier-invoices': {
      id: '/_auth/o/$orgId/finance/supplier-invoices'
      path: '/supplier-invoices'
      fullPath: '/o/$orgId/finance/supplier-invoices'
      preLoaderRoute: typeof AuthOOrgIdFinanceSupplierInvoicesRouteImport
      parentRoute: typeof AuthOOrgIdFinanceRoute
    }
    '/_auth/o/$orgId/finance/suppliers': {
      id: '/_auth/o/$orgId/finance/suppliers'
      path: '/suppliers'
      fullPath: '/o/$orgId/finance/suppliers'
      preLoaderRoute: typeof AuthOOrgIdFinanceSuppliersRouteImport
      parentRoute: typeof AuthOOrgIdFinanceRoute
    }
    '/_auth/o/$orgId/finance/treasury': {
      id: '/_auth/o/$orgId/finance/treasury'
      path: '/treasury'
      fullPath: '/o/$orgId/finance/treasury'
      preLoaderRoute: typeof AuthOOrgIdFinanceTreasuryRouteImport
      parentRoute: typeof AuthOOrgIdFinanceRoute
    }
    '/_auth/o/$orgId/finance/withholding': {
      id: '/_auth/o/$orgId/finance/withholding'
      path: '/withholding'
      fullPath: '/o/$orgId/finance/withholding'
      preLoaderRoute: typeof AuthOOrgIdFinanceWithholdingRouteImport
      parentRoute: typeof AuthOOrgIdFinanceRoute
    }
    '/_auth/o/$orgId/meetings/$meetingId': {
      id: '/_auth/o/$orgId/meetings/$meetingId'
      path: '/meetings/$meetingId'
      fullPath: '/o/$orgId/meetings/$meetingId'
      preLoaderRoute: typeof AuthOOrgIdMeetingsMeetingIdRouteImport
      parentRoute: typeof AuthOOrgIdRoute
    }
    '/_auth/o/$orgId/projects/': {
      id: '/_auth/o/$orgId/projects/'
      path: '/projects'
      fullPath: '/o/$orgId/projects/'
      preLoaderRoute: typeof AuthOOrgIdProjectsIndexRouteImport
      parentRoute: typeof AuthOOrgIdRoute
    }
    '/_auth/o/$orgId/signatures/': {
      id: '/_auth/o/$orgId/signatures/'
      path: '/signatures'
      fullPath: '/o/$orgId/signatures/'
      preLoaderRoute: typeof AuthOOrgIdSignaturesIndexRouteImport
      parentRoute: typeof AuthOOrgIdRoute
    }
    '/_auth/o/$orgId/signatures/$requestId': {
      id: '/_auth/o/$orgId/signatures/$requestId'
      path: '/signatures/$requestId'
      fullPath: '/o/$orgId/signatures/$requestId'
      preLoaderRoute: typeof AuthOOrgIdSignaturesRequestIdRouteImport
      parentRoute: typeof AuthOOrgIdRoute
    }
    '/_auth/o/$orgId/tenders/': {
      id: '/_auth/o/$orgId/tenders/'
      path: '/tenders'
      fullPath: '/o/$orgId/tenders/'
      preLoaderRoute: typeof AuthOOrgIdTendersIndexRouteImport
      parentRoute: typeof AuthOOrgIdRoute
    }
    '/_auth/o/$orgId/tenders/$tenderId': {
      id: '/_auth/o/$orgId/tenders/$tenderId'
      path: '/tenders/$tenderId'
      fullPath: '/o/$orgId/tenders/$tenderId'
      preLoaderRoute: typeof AuthOOrgIdTendersTenderIdRouteImport
      parentRoute: typeof AuthOOrgIdRoute
    }
    '/_auth/o/$orgId/tenders/vault': {
      id: '/_auth/o/$orgId/tenders/vault'
      path: '/tenders/vault'
      fullPath: '/o/$orgId/tenders/vault'
      preLoaderRoute: typeof AuthOOrgIdTendersVaultRouteImport
      parentRoute: typeof AuthOOrgIdRoute
    }
    '/_auth/o/$orgId/finance/contracts/': {
      id: '/_auth/o/$orgId/finance/contracts/'
      path: '/contracts'
      fullPath: '/o/$orgId/finance/contracts/'
      preLoaderRoute: typeof AuthOOrgIdFinanceContractsIndexRouteImport
      parentRoute: typeof AuthOOrgIdFinanceRoute
    }
    '/_auth/o/$orgId/finance/contracts/new': {
      id: '/_auth/o/$orgId/finance/contracts/new'
      path: '/contracts/new'
      fullPath: '/o/$orgId/finance/contracts/new'
      preLoaderRoute: typeof AuthOOrgIdFinanceContractsNewRouteImport
      parentRoute: typeof AuthOOrgIdFinanceRoute
    }
    '/_auth/o/$orgId/finance/expenses/': {
      id: '/_auth/o/$orgId/finance/expenses/'
      path: '/expenses'
      fullPath: '/o/$orgId/finance/expenses/'
      preLoaderRoute: typeof AuthOOrgIdFinanceExpensesIndexRouteImport
      parentRoute: typeof AuthOOrgIdFinanceRoute
    }
    '/_auth/o/$orgId/finance/expenses/approvals': {
      id: '/_auth/o/$orgId/finance/expenses/approvals'
      path: '/expenses/approvals'
      fullPath: '/o/$orgId/finance/expenses/approvals'
      preLoaderRoute: typeof AuthOOrgIdFinanceExpensesApprovalsRouteImport
      parentRoute: typeof AuthOOrgIdFinanceRoute
    }
    '/_auth/o/$orgId/finance/invoices/': {
      id: '/_auth/o/$orgId/finance/invoices/'
      path: '/invoices'
      fullPath: '/o/$orgId/finance/invoices/'
      preLoaderRoute: typeof AuthOOrgIdFinanceInvoicesIndexRouteImport
      parentRoute: typeof AuthOOrgIdFinanceRoute
    }
    '/_auth/o/$orgId/finance/invoices/$invoiceId': {
      id: '/_auth/o/$orgId/finance/invoices/$invoiceId'
      path: '/invoices/$invoiceId'
      fullPath: '/o/$orgId/finance/invoices/$invoiceId'
      preLoaderRoute: typeof AuthOOrgIdFinanceInvoicesInvoiceIdRouteImport
      parentRoute: typeof AuthOOrgIdFinanceRoute
    }
    '/_auth/o/$orgId/finance/invoices/new': {
      id: '/_auth/o/$orgId/finance/invoices/new'
      path: '/invoices/new'
      fullPath: '/o/$orgId/finance/invoices/new'
      preLoaderRoute: typeof AuthOOrgIdFinanceInvoicesNewRouteImport
      parentRoute: typeof AuthOOrgIdFinanceRoute
    }
    '/_auth/o/$orgId/finance/quotes/': {
      id: '/_auth/o/$orgId/finance/quotes/'
      path: '/quotes'
      fullPath: '/o/$orgId/finance/quotes/'
      preLoaderRoute: typeof AuthOOrgIdFinanceQuotesIndexRouteImport
      parentRoute: typeof AuthOOrgIdFinanceRoute
    }
    '/_auth/o/$orgId/finance/quotes/$quoteId': {
      id: '/_auth/o/$orgId/finance/quotes/$quoteId'
      path: '/quotes/$quoteId'
      fullPath: '/o/$orgId/finance/quotes/$quoteId'
      preLoaderRoute: typeof AuthOOrgIdFinanceQuotesQuoteIdRouteImport
      parentRoute: typeof AuthOOrgIdFinanceRoute
    }
    '/_auth/o/$orgId/finance/quotes/new': {
      id: '/_auth/o/$orgId/finance/quotes/new'
      path: '/quotes/new'
      fullPath: '/o/$orgId/finance/quotes/new'
      preLoaderRoute: typeof AuthOOrgIdFinanceQuotesNewRouteImport
      parentRoute: typeof AuthOOrgIdFinanceRoute
    }
    '/_auth/o/$orgId/projects/$projectId/': {
      id: '/_auth/o/$orgId/projects/$projectId/'
      path: '/projects/$projectId'
      fullPath: '/o/$orgId/projects/$projectId/'
      preLoaderRoute: typeof AuthOOrgIdProjectsProjectIdIndexRouteImport
      parentRoute: typeof AuthOOrgIdRoute
    }
    '/_auth/o/$orgId/projects/$projectId/$tab': {
      id: '/_auth/o/$orgId/projects/$projectId/$tab'
      path: '/projects/$projectId/$tab'
      fullPath: '/o/$orgId/projects/$projectId/$tab'
      preLoaderRoute: typeof AuthOOrgIdProjectsProjectIdTabRouteImport
      parentRoute: typeof AuthOOrgIdRoute
    }
    '/_auth/o/$orgId/finance/contracts/$contractId/': {
      id: '/_auth/o/$orgId/finance/contracts/$contractId/'
      path: '/contracts/$contractId'
      fullPath: '/o/$orgId/finance/contracts/$contractId/'
      preLoaderRoute: typeof AuthOOrgIdFinanceContractsContractIdIndexRouteImport
      parentRoute: typeof AuthOOrgIdFinanceRoute
    }
    '/_auth/o/$orgId/finance/contracts/$contractId/progress': {
      id: '/_auth/o/$orgId/finance/contracts/$contractId/progress'
      path: '/contracts/$contractId/progress'
      fullPath: '/o/$orgId/finance/contracts/$contractId/progress'
      preLoaderRoute: typeof AuthOOrgIdFinanceContractsContractIdProgressRouteImport
      parentRoute: typeof AuthOOrgIdFinanceRoute
    }
    '/_auth/o/$orgId/projects/$projectId/documents/$documentId': {
      id: '/_auth/o/$orgId/projects/$projectId/documents/$documentId'
      path: '/projects/$projectId/documents/$documentId'
      fullPath: '/o/$orgId/projects/$projectId/documents/$documentId'
      preLoaderRoute: typeof AuthOOrgIdProjectsProjectIdDocumentsDocumentIdRouteImport
      parentRoute: typeof AuthOOrgIdRoute
    }
    '/_auth/o/$orgId/projects/$projectId/workspace/$section': {
      id: '/_auth/o/$orgId/projects/$projectId/workspace/$section'
      path: '/projects/$projectId/workspace/$section'
      fullPath: '/o/$orgId/projects/$projectId/workspace/$section'
      preLoaderRoute: typeof AuthOOrgIdProjectsProjectIdWorkspaceSectionRouteImport
      parentRoute: typeof AuthOOrgIdRoute
    }
  }
}

interface AuthMeRouteChildren {
  AuthMeNotificationsRoute: typeof AuthMeNotificationsRoute
  AuthMeProfileRoute: typeof AuthMeProfileRoute
  AuthMeSecurityRoute: typeof AuthMeSecurityRoute
  AuthMeIndexRoute: typeof AuthMeIndexRoute
}

const AuthMeRouteChildren: AuthMeRouteChildren = {
  AuthMeNotificationsRoute: AuthMeNotificationsRoute,
  AuthMeProfileRoute: AuthMeProfileRoute,
  AuthMeSecurityRoute: AuthMeSecurityRoute,
  AuthMeIndexRoute: AuthMeIndexRoute,
}

const AuthMeRouteWithChildren =
  AuthMeRoute._addFileChildren(AuthMeRouteChildren)

interface AuthSpacesRouteChildren {
  AuthSpacesIndexRoute: typeof AuthSpacesIndexRoute
}

const AuthSpacesRouteChildren: AuthSpacesRouteChildren = {
  AuthSpacesIndexRoute: AuthSpacesIndexRoute,
}

const AuthSpacesRouteWithChildren = AuthSpacesRoute._addFileChildren(
  AuthSpacesRouteChildren,
)

interface AuthOOrgIdAdminRouteChildren {
  AuthOOrgIdAdminAuditRoute: typeof AuthOOrgIdAdminAuditRoute
  AuthOOrgIdAdminChecklistsRoute: typeof AuthOOrgIdAdminChecklistsRoute
  AuthOOrgIdAdminDataRoute: typeof AuthOOrgIdAdminDataRoute
  AuthOOrgIdAdminDocumentsRoute: typeof AuthOOrgIdAdminDocumentsRoute
  AuthOOrgIdAdminFiscalRoute: typeof AuthOOrgIdAdminFiscalRoute
  AuthOOrgIdAdminMembersRoute: typeof AuthOOrgIdAdminMembersRoute
  AuthOOrgIdAdminPoliciesRoute: typeof AuthOOrgIdAdminPoliciesRoute
  AuthOOrgIdAdminProfileRoute: typeof AuthOOrgIdAdminProfileRoute
  AuthOOrgIdAdminRolesRoute: typeof AuthOOrgIdAdminRolesRoute
  AuthOOrgIdAdminStorageRoute: typeof AuthOOrgIdAdminStorageRoute
  AuthOOrgIdAdminSubscriptionRoute: typeof AuthOOrgIdAdminSubscriptionRoute
  AuthOOrgIdAdminTemplatesRoute: typeof AuthOOrgIdAdminTemplatesRoute
  AuthOOrgIdAdminIndexRoute: typeof AuthOOrgIdAdminIndexRoute
}

const AuthOOrgIdAdminRouteChildren: AuthOOrgIdAdminRouteChildren = {
  AuthOOrgIdAdminAuditRoute: AuthOOrgIdAdminAuditRoute,
  AuthOOrgIdAdminChecklistsRoute: AuthOOrgIdAdminChecklistsRoute,
  AuthOOrgIdAdminDataRoute: AuthOOrgIdAdminDataRoute,
  AuthOOrgIdAdminDocumentsRoute: AuthOOrgIdAdminDocumentsRoute,
  AuthOOrgIdAdminFiscalRoute: AuthOOrgIdAdminFiscalRoute,
  AuthOOrgIdAdminMembersRoute: AuthOOrgIdAdminMembersRoute,
  AuthOOrgIdAdminPoliciesRoute: AuthOOrgIdAdminPoliciesRoute,
  AuthOOrgIdAdminProfileRoute: AuthOOrgIdAdminProfileRoute,
  AuthOOrgIdAdminRolesRoute: AuthOOrgIdAdminRolesRoute,
  AuthOOrgIdAdminStorageRoute: AuthOOrgIdAdminStorageRoute,
  AuthOOrgIdAdminSubscriptionRoute: AuthOOrgIdAdminSubscriptionRoute,
  AuthOOrgIdAdminTemplatesRoute: AuthOOrgIdAdminTemplatesRoute,
  AuthOOrgIdAdminIndexRoute: AuthOOrgIdAdminIndexRoute,
}

const AuthOOrgIdAdminRouteWithChildren = AuthOOrgIdAdminRoute._addFileChildren(
  AuthOOrgIdAdminRouteChildren,
)

interface AuthOOrgIdFinanceRouteChildren {
  AuthOOrgIdFinanceAccountingRoute: typeof AuthOOrgIdFinanceAccountingRoute
  AuthOOrgIdFinanceCostRatesRoute: typeof AuthOOrgIdFinanceCostRatesRoute
  AuthOOrgIdFinanceDashboardRoute: typeof AuthOOrgIdFinanceDashboardRoute
  AuthOOrgIdFinanceEinvoicingRoute: typeof AuthOOrgIdFinanceEinvoicingRoute
  AuthOOrgIdFinanceManagementRoute: typeof AuthOOrgIdFinanceManagementRoute
  AuthOOrgIdFinancePaymentsRoute: typeof AuthOOrgIdFinancePaymentsRoute
  AuthOOrgIdFinanceProfitabilityRoute: typeof AuthOOrgIdFinanceProfitabilityRoute
  AuthOOrgIdFinanceSupplierInvoicesRoute: typeof AuthOOrgIdFinanceSupplierInvoicesRoute
  AuthOOrgIdFinanceSuppliersRoute: typeof AuthOOrgIdFinanceSuppliersRoute
  AuthOOrgIdFinanceTreasuryRoute: typeof AuthOOrgIdFinanceTreasuryRoute
  AuthOOrgIdFinanceWithholdingRoute: typeof AuthOOrgIdFinanceWithholdingRoute
  AuthOOrgIdFinanceIndexRoute: typeof AuthOOrgIdFinanceIndexRoute
  AuthOOrgIdFinanceContractsNewRoute: typeof AuthOOrgIdFinanceContractsNewRoute
  AuthOOrgIdFinanceExpensesApprovalsRoute: typeof AuthOOrgIdFinanceExpensesApprovalsRoute
  AuthOOrgIdFinanceInvoicesInvoiceIdRoute: typeof AuthOOrgIdFinanceInvoicesInvoiceIdRoute
  AuthOOrgIdFinanceInvoicesNewRoute: typeof AuthOOrgIdFinanceInvoicesNewRoute
  AuthOOrgIdFinanceQuotesQuoteIdRoute: typeof AuthOOrgIdFinanceQuotesQuoteIdRoute
  AuthOOrgIdFinanceQuotesNewRoute: typeof AuthOOrgIdFinanceQuotesNewRoute
  AuthOOrgIdFinanceContractsIndexRoute: typeof AuthOOrgIdFinanceContractsIndexRoute
  AuthOOrgIdFinanceExpensesIndexRoute: typeof AuthOOrgIdFinanceExpensesIndexRoute
  AuthOOrgIdFinanceInvoicesIndexRoute: typeof AuthOOrgIdFinanceInvoicesIndexRoute
  AuthOOrgIdFinanceQuotesIndexRoute: typeof AuthOOrgIdFinanceQuotesIndexRoute
  AuthOOrgIdFinanceContractsContractIdProgressRoute: typeof AuthOOrgIdFinanceContractsContractIdProgressRoute
  AuthOOrgIdFinanceContractsContractIdIndexRoute: typeof AuthOOrgIdFinanceContractsContractIdIndexRoute
}

const AuthOOrgIdFinanceRouteChildren: AuthOOrgIdFinanceRouteChildren = {
  AuthOOrgIdFinanceAccountingRoute: AuthOOrgIdFinanceAccountingRoute,
  AuthOOrgIdFinanceCostRatesRoute: AuthOOrgIdFinanceCostRatesRoute,
  AuthOOrgIdFinanceDashboardRoute: AuthOOrgIdFinanceDashboardRoute,
  AuthOOrgIdFinanceEinvoicingRoute: AuthOOrgIdFinanceEinvoicingRoute,
  AuthOOrgIdFinanceManagementRoute: AuthOOrgIdFinanceManagementRoute,
  AuthOOrgIdFinancePaymentsRoute: AuthOOrgIdFinancePaymentsRoute,
  AuthOOrgIdFinanceProfitabilityRoute: AuthOOrgIdFinanceProfitabilityRoute,
  AuthOOrgIdFinanceSupplierInvoicesRoute:
    AuthOOrgIdFinanceSupplierInvoicesRoute,
  AuthOOrgIdFinanceSuppliersRoute: AuthOOrgIdFinanceSuppliersRoute,
  AuthOOrgIdFinanceTreasuryRoute: AuthOOrgIdFinanceTreasuryRoute,
  AuthOOrgIdFinanceWithholdingRoute: AuthOOrgIdFinanceWithholdingRoute,
  AuthOOrgIdFinanceIndexRoute: AuthOOrgIdFinanceIndexRoute,
  AuthOOrgIdFinanceContractsNewRoute: AuthOOrgIdFinanceContractsNewRoute,
  AuthOOrgIdFinanceExpensesApprovalsRoute:
    AuthOOrgIdFinanceExpensesApprovalsRoute,
  AuthOOrgIdFinanceInvoicesInvoiceIdRoute:
    AuthOOrgIdFinanceInvoicesInvoiceIdRoute,
  AuthOOrgIdFinanceInvoicesNewRoute: AuthOOrgIdFinanceInvoicesNewRoute,
  AuthOOrgIdFinanceQuotesQuoteIdRoute: AuthOOrgIdFinanceQuotesQuoteIdRoute,
  AuthOOrgIdFinanceQuotesNewRoute: AuthOOrgIdFinanceQuotesNewRoute,
  AuthOOrgIdFinanceContractsIndexRoute: AuthOOrgIdFinanceContractsIndexRoute,
  AuthOOrgIdFinanceExpensesIndexRoute: AuthOOrgIdFinanceExpensesIndexRoute,
  AuthOOrgIdFinanceInvoicesIndexRoute: AuthOOrgIdFinanceInvoicesIndexRoute,
  AuthOOrgIdFinanceQuotesIndexRoute: AuthOOrgIdFinanceQuotesIndexRoute,
  AuthOOrgIdFinanceContractsContractIdProgressRoute:
    AuthOOrgIdFinanceContractsContractIdProgressRoute,
  AuthOOrgIdFinanceContractsContractIdIndexRoute:
    AuthOOrgIdFinanceContractsContractIdIndexRoute,
}

const AuthOOrgIdFinanceRouteWithChildren =
  AuthOOrgIdFinanceRoute._addFileChildren(AuthOOrgIdFinanceRouteChildren)

interface AuthOOrgIdRouteChildren {
  AuthOOrgIdActivityRoute: typeof AuthOOrgIdActivityRoute
  AuthOOrgIdAdminRoute: typeof AuthOOrgIdAdminRouteWithChildren
  AuthOOrgIdCalendarRoute: typeof AuthOOrgIdCalendarRoute
  AuthOOrgIdDirectoryRoute: typeof AuthOOrgIdDirectoryRoute
  AuthOOrgIdFilesRoute: typeof AuthOOrgIdFilesRoute
  AuthOOrgIdFinanceRoute: typeof AuthOOrgIdFinanceRouteWithChildren
  AuthOOrgIdMoreRoute: typeof AuthOOrgIdMoreRoute
  AuthOOrgIdPartnershipsRoute: typeof AuthOOrgIdPartnershipsRoute
  AuthOOrgIdSearchRoute: typeof AuthOOrgIdSearchRoute
  AuthOOrgIdSpaceApprovalsRoute: typeof AuthOOrgIdSpaceApprovalsRoute
  AuthOOrgIdTimesheetsRoute: typeof AuthOOrgIdTimesheetsRoute
  AuthOOrgIdIndexRoute: typeof AuthOOrgIdIndexRoute
  AuthOOrgIdChatChannelIdRoute: typeof AuthOOrgIdChatChannelIdRoute
  AuthOOrgIdClientsClientIdRoute: typeof AuthOOrgIdClientsClientIdRoute
  AuthOOrgIdMeetingsMeetingIdRoute: typeof AuthOOrgIdMeetingsMeetingIdRoute
  AuthOOrgIdSignaturesRequestIdRoute: typeof AuthOOrgIdSignaturesRequestIdRoute
  AuthOOrgIdTendersTenderIdRoute: typeof AuthOOrgIdTendersTenderIdRoute
  AuthOOrgIdTendersVaultRoute: typeof AuthOOrgIdTendersVaultRoute
  AuthOOrgIdChatIndexRoute: typeof AuthOOrgIdChatIndexRoute
  AuthOOrgIdClientsIndexRoute: typeof AuthOOrgIdClientsIndexRoute
  AuthOOrgIdProjectsIndexRoute: typeof AuthOOrgIdProjectsIndexRoute
  AuthOOrgIdSignaturesIndexRoute: typeof AuthOOrgIdSignaturesIndexRoute
  AuthOOrgIdTendersIndexRoute: typeof AuthOOrgIdTendersIndexRoute
  AuthOOrgIdProjectsProjectIdTabRoute: typeof AuthOOrgIdProjectsProjectIdTabRoute
  AuthOOrgIdProjectsProjectIdIndexRoute: typeof AuthOOrgIdProjectsProjectIdIndexRoute
  AuthOOrgIdProjectsProjectIdDocumentsDocumentIdRoute: typeof AuthOOrgIdProjectsProjectIdDocumentsDocumentIdRoute
  AuthOOrgIdProjectsProjectIdWorkspaceSectionRoute: typeof AuthOOrgIdProjectsProjectIdWorkspaceSectionRoute
}

const AuthOOrgIdRouteChildren: AuthOOrgIdRouteChildren = {
  AuthOOrgIdActivityRoute: AuthOOrgIdActivityRoute,
  AuthOOrgIdAdminRoute: AuthOOrgIdAdminRouteWithChildren,
  AuthOOrgIdCalendarRoute: AuthOOrgIdCalendarRoute,
  AuthOOrgIdDirectoryRoute: AuthOOrgIdDirectoryRoute,
  AuthOOrgIdFilesRoute: AuthOOrgIdFilesRoute,
  AuthOOrgIdFinanceRoute: AuthOOrgIdFinanceRouteWithChildren,
  AuthOOrgIdMoreRoute: AuthOOrgIdMoreRoute,
  AuthOOrgIdPartnershipsRoute: AuthOOrgIdPartnershipsRoute,
  AuthOOrgIdSearchRoute: AuthOOrgIdSearchRoute,
  AuthOOrgIdSpaceApprovalsRoute: AuthOOrgIdSpaceApprovalsRoute,
  AuthOOrgIdTimesheetsRoute: AuthOOrgIdTimesheetsRoute,
  AuthOOrgIdIndexRoute: AuthOOrgIdIndexRoute,
  AuthOOrgIdChatChannelIdRoute: AuthOOrgIdChatChannelIdRoute,
  AuthOOrgIdClientsClientIdRoute: AuthOOrgIdClientsClientIdRoute,
  AuthOOrgIdMeetingsMeetingIdRoute: AuthOOrgIdMeetingsMeetingIdRoute,
  AuthOOrgIdSignaturesRequestIdRoute: AuthOOrgIdSignaturesRequestIdRoute,
  AuthOOrgIdTendersTenderIdRoute: AuthOOrgIdTendersTenderIdRoute,
  AuthOOrgIdTendersVaultRoute: AuthOOrgIdTendersVaultRoute,
  AuthOOrgIdChatIndexRoute: AuthOOrgIdChatIndexRoute,
  AuthOOrgIdClientsIndexRoute: AuthOOrgIdClientsIndexRoute,
  AuthOOrgIdProjectsIndexRoute: AuthOOrgIdProjectsIndexRoute,
  AuthOOrgIdSignaturesIndexRoute: AuthOOrgIdSignaturesIndexRoute,
  AuthOOrgIdTendersIndexRoute: AuthOOrgIdTendersIndexRoute,
  AuthOOrgIdProjectsProjectIdTabRoute: AuthOOrgIdProjectsProjectIdTabRoute,
  AuthOOrgIdProjectsProjectIdIndexRoute: AuthOOrgIdProjectsProjectIdIndexRoute,
  AuthOOrgIdProjectsProjectIdDocumentsDocumentIdRoute:
    AuthOOrgIdProjectsProjectIdDocumentsDocumentIdRoute,
  AuthOOrgIdProjectsProjectIdWorkspaceSectionRoute:
    AuthOOrgIdProjectsProjectIdWorkspaceSectionRoute,
}

const AuthOOrgIdRouteWithChildren = AuthOOrgIdRoute._addFileChildren(
  AuthOOrgIdRouteChildren,
)

interface AuthSSpaceIdRouteChildren {
  AuthSSpaceIdTabRoute: typeof AuthSSpaceIdTabRoute
  AuthSSpaceIdIndexRoute: typeof AuthSSpaceIdIndexRoute
}

const AuthSSpaceIdRouteChildren: AuthSSpaceIdRouteChildren = {
  AuthSSpaceIdTabRoute: AuthSSpaceIdTabRoute,
  AuthSSpaceIdIndexRoute: AuthSSpaceIdIndexRoute,
}

const AuthSSpaceIdRouteWithChildren = AuthSSpaceIdRoute._addFileChildren(
  AuthSSpaceIdRouteChildren,
)

interface AuthRouteChildren {
  AuthMeRoute: typeof AuthMeRouteWithChildren
  AuthOnboardingRoute: typeof AuthOnboardingRoute
  AuthSpacesRoute: typeof AuthSpacesRouteWithChildren
  AuthIndexRoute: typeof AuthIndexRoute
  AuthCallsMeetingIdRoute: typeof AuthCallsMeetingIdRoute
  AuthInvitationsSpacesRoute: typeof AuthInvitationsSpacesRoute
  AuthMeetingsMeetingIdRoute: typeof AuthMeetingsMeetingIdRoute
  AuthMeetingsGuestRoute: typeof AuthMeetingsGuestRoute
  AuthMinutesNewRoute: typeof AuthMinutesNewRoute
  AuthOOrgIdRoute: typeof AuthOOrgIdRouteWithChildren
  AuthSSpaceIdRoute: typeof AuthSSpaceIdRouteWithChildren
  AuthMinutesSpaceIdMinutesIdRoute: typeof AuthMinutesSpaceIdMinutesIdRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthMeRoute: AuthMeRouteWithChildren,
  AuthOnboardingRoute: AuthOnboardingRoute,
  AuthSpacesRoute: AuthSpacesRouteWithChildren,
  AuthIndexRoute: AuthIndexRoute,
  AuthCallsMeetingIdRoute: AuthCallsMeetingIdRoute,
  AuthInvitationsSpacesRoute: AuthInvitationsSpacesRoute,
  AuthMeetingsMeetingIdRoute: AuthMeetingsMeetingIdRoute,
  AuthMeetingsGuestRoute: AuthMeetingsGuestRoute,
  AuthMinutesNewRoute: AuthMinutesNewRoute,
  AuthOOrgIdRoute: AuthOOrgIdRouteWithChildren,
  AuthSSpaceIdRoute: AuthSSpaceIdRouteWithChildren,
  AuthMinutesSpaceIdMinutesIdRoute: AuthMinutesSpaceIdMinutesIdRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  SignedOutRoute: SignedOutRoute,
  InvitationsTokenRoute: InvitationsTokenRoute,
  InvitationsAcceptRoute: InvitationsAcceptRoute,
  LTokenRoute: LTokenRoute,
  QTokenRoute: QTokenRoute,
  TTokenRoute: TTokenRoute,
  MeetingsJoinTokenRoute: MeetingsJoinTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
